(function() {
  const customIconHTML = `<span class="icon icon-garage inline-flex"><svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5045 15.5537H20.7638V6.9129C20.7638 6.66911 20.7037 6.4291 20.5887 6.21414C20.4737 5.99918 20.3074 5.81592 20.1046 5.68062L11.9574 0.248776C11.7141 0.0865614 11.4282 0 11.1357 0C10.8433 0 10.5574 0.0865614 10.3141 0.248776L2.16682 5.68062C1.96386 5.81581 1.79741 5.99902 1.68226 6.21399C1.5671 6.42896 1.5068 6.66903 1.50671 6.9129V15.5537H0.766049C0.569614 15.5537 0.381225 15.6317 0.242324 15.7706C0.103424 15.9095 0.0253906 16.0979 0.0253906 16.2943C0.0253906 16.4908 0.103424 16.6792 0.242324 16.8181C0.381225 16.957 0.569614 17.035 0.766049 17.035H21.5045C21.7009 17.035 21.8893 16.957 22.0282 16.8181C22.1671 16.6792 22.2451 16.4908 22.2451 16.2943C22.2451 16.0979 22.1671 15.9095 22.0282 15.7706C21.8893 15.6317 21.7009 15.5537 21.5045 15.5537ZM2.98802 6.9129L11.1353 1.48106L19.2825 6.91197V15.5537H17.0605V10.369C17.0605 10.1726 16.9825 9.98419 16.8436 9.84529C16.7047 9.70639 16.5163 9.62835 16.3199 9.62835H5.95066C5.75422 9.62835 5.56583 9.70639 5.42693 9.84529C5.28803 9.98419 5.21 10.1726 5.21 10.369V15.5537H2.98802V6.9129ZM15.5792 11.1097V12.591H11.8759V11.1097H15.5792ZM10.3946 12.591H6.69132V11.1097H10.3946V12.591ZM6.69132 14.0723H10.3946V15.5537H6.69132V14.0723ZM11.8759 14.0723H15.5792V15.5537H11.8759V14.0723Z" fill="#262626"/>
  </svg></span>`;

  (function ensureGarageIconDedupeStyles() {
    const css = `
      /* Convermax garage sometimes renders an icon via pseudo-element */
      .cm_toggle-dropdown::before,
      .cm_toggle-dropdown::after,
      .garage-button::before,
      .garage-button::after,
      .cm_toggle-dropdown.garage-button::before,
      .cm_toggle-dropdown.garage-button::after,
      #cm-garage .cm_toggle-dropdown::before,
      #cm-garage .cm_toggle-dropdown::after,
      #cm-garage .garage-button::before,
      #cm-garage .garage-button::after,
      #cm-garage .cm_toggle-dropdown.garage-button::before,
      #cm-garage .cm_toggle-dropdown.garage-button::after {
        content: none !important;
        display: none !important;
        background: none !important;
        background-image: none !important;
        -webkit-mask-image: none !important;
        mask-image: none !important;
      }

      .cm_toggle-dropdown,
      .garage-button,
      .cm_toggle-dropdown.garage-button,
      #cm-garage .cm_toggle-dropdown,
      #cm-garage .garage-button,
      #cm-garage .cm_toggle-dropdown.garage-button {
        background: none !important;
        background-image: none !important;
      }
    `;

    let style = document.getElementById('cm-garage-icon-dedupe-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'cm-garage-icon-dedupe-style';
      (document.head || document.documentElement).appendChild(style);
    }
    style.textContent = css;
  })();
  
  let isProcessing = false;

  function getGarageContainers() {
    // Some themes clone the header for sticky behavior which can duplicate #cm-garage in the DOM.
    return Array.from(document.querySelectorAll('#cm-garage'));
  }

  function isElementVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    try {
      const rect = el.getBoundingClientRect();
      if (!rect || rect.width === 0 || rect.height === 0) return false;
      const style = window.getComputedStyle(el);
      if (!style || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function hideDuplicateVisibleGarages() {
    const garages = getGarageContainers();
    if (garages.length <= 1) return;

    const visible = garages.filter((g) => isElementVisible(g));
    if (visible.length <= 1) return;

    // Keep the first visible, hide the rest.
    visible.forEach((g, idx) => {
      if (idx === 0) return;
      try {
        g.setAttribute('data-cm-garage-hidden-duplicate', '1');
        g.style.setProperty('display', 'none', 'important');
      } catch (e) {}
    });
  }

  function normalizeGarageToggleButton(toggleButton) {
    if (!toggleButton || toggleButton.nodeType !== 1) return;

    try {
      toggleButton.style.setProperty('background-image', 'none', 'important');
    } catch (e) {}

    // Ensure exactly one custom icon exists.
    const customIcons = Array.from(toggleButton.querySelectorAll('.icon-garage'));
    let keepIcon = customIcons[0] || null;

    if (!keepIcon) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = customIconHTML;
      keepIcon = tempDiv.firstElementChild;
      if (keepIcon) toggleButton.insertBefore(keepIcon, toggleButton.firstChild);
    }

    // Remove any additional custom icons.
    customIcons.forEach((ci, idx) => {
      if (idx === 0) return;
      try { ci.remove(); } catch (e) {}
    });

    // Remove any other icon/svg elements inside the toggle that are not part of the kept icon.
    // This is the hard-stop for cases where Convermax injects another icon alongside ours.
    try {
      const maybeIcons = Array.from(toggleButton.querySelectorAll('svg, span.icon, i, [class*="cm_icon"], .garage-icon, .cm_icon_garage__background, .garage-size'));
      maybeIcons.forEach((node) => {
        if (!node || node.nodeType !== 1) return;
        if (keepIcon && (node === keepIcon || keepIcon.contains(node))) return;
        // Don't remove the label text container.
        if (node.classList && node.classList.contains('header-icon-text')) return;
        try { node.remove(); } catch (e) {}
      });
    } catch (e) {}

    // Final normalization: keep only [icon][label] inside the toggle.
    try {
      const labelEl =
        toggleButton.querySelector('.header-icon-text') ||
        toggleButton.querySelector('.garage-label') ||
        null;

      // If label is missing, create one.
      const ensuredLabel = labelEl || (function() {
        const span = document.createElement('span');
        span.className = 'header-icon-text';
        span.textContent = 'My Garage';
        toggleButton.appendChild(span);
        return span;
      })();

      // Clear children and rebuild.
      const nodesToRemove = Array.from(toggleButton.childNodes);
      nodesToRemove.forEach((n) => {
        try { n.remove(); } catch (e) { try { toggleButton.removeChild(n); } catch(_) {} }
      });

      if (keepIcon) toggleButton.appendChild(keepIcon);
      toggleButton.appendChild(ensuredLabel);
    } catch (e) {}
  }

  function processGarageContainer(garage) {
    if (!garage) return;

    const firstRun = !garage.hasAttribute('data-custom-processed');

    if (firstRun) {
      isProcessing = true;
      garage.style.opacity = '0';
      garage.style.visibility = 'hidden';
    }

    const widgetRoot = garage.querySelector('.cm_garage') || garage;
    const toggleButton = widgetRoot.querySelector('.cm_toggle-dropdown, .garage-button, button, a');
    if (!toggleButton) {
      if (firstRun) {
        garage.style.opacity = '1';
        garage.style.visibility = 'visible';
        isProcessing = false;
      }
      return;
    }
        (function gateForLogin() {
          const isCustomerLoggedIn = function() {
            try {
              const logoutBtn = document.querySelector('.btn-logout, a.btn-logout');
              if (logoutBtn) return true;
              const logoutLink = document.querySelector('a[href*="/account/logout"]');
              if (logoutLink) return true;
              const loginBtn = document.querySelector('.btn-login, a.btn-login');
              if (loginBtn) return false;
              const cls = (document.body && document.body.className) || '';
              if (/\bcustomer-logged-in\b/.test(cls)) return true;
              if (/\bcustomer-logged-out\b/.test(cls)) return false;
            } catch(_) {}
            return false;
          };

          if (toggleButton.__loginGateBound) return;

          const intercept = function(ev) {
            if (isCustomerLoggedIn()) return;
            try {
              ev.preventDefault();
              ev.stopImmediatePropagation();
            } catch (_) {}
            showLoginDropdown();
            return false;
          };

          toggleButton.addEventListener('click', intercept, true);
          
          toggleButton.addEventListener('keydown', function(e){
            const k = e.key || e.code;
            if (k === 'Enter' || k === ' ' || k === 'Spacebar' || k === 'Space') {
              intercept(e);
            }
          }, true);

          toggleButton.__loginGateBound = true;
        })();

        function showLoginDropdown() {
          const host = garage || document.body;
          const oldDiv = document.getElementById('garage-login-dropdown');
          if (oldDiv) try { oldDiv.remove(); } catch(_) {}

          let dd = document.getElementById('garage-login-details');
          if (!dd) {
            dd = document.createElement('details');
            dd.id = 'garage-login-details';
            dd.className = 'dropdown-component';
            dd.innerHTML = `
              <summary class="dropdown-summary" style="display:none"></summary>
              <div class="dropdown-layer dropdown-component-UI-color absolute">
                <div class="dropdown-inner relative">
                  <div class="dropdown-content">
                    <p class="dropdown-content-subtext">
                      <a class="underline" href="/account/login">Login</a><br>
                      <span>or</span><br>
                      <a class="underline" href="/account/register">create an account</a><br>
                      <span>to save your ride</span>
                    </p>
                  </div>
                </div>
              </div>`;
            host.appendChild(dd);

            const outside = (e) => {
              if (!dd.contains(e.target) && e.target !== toggleButton && !toggleButton.contains(e.target)) {
                dd.open = false;
                document.removeEventListener('mousedown', outside, true);
                document.removeEventListener('touchstart', outside, true);
                document.removeEventListener('keydown', onKey, true);
              }
            };
            const onKey = (e) => {
              if (e.key === 'Escape') {
                dd.open = false;
                document.removeEventListener('mousedown', outside, true);
                document.removeEventListener('touchstart', outside, true);
                document.removeEventListener('keydown', onKey, true);
              }
            };

            dd.__bindClose = function() {
              document.addEventListener('mousedown', outside, true);
              document.addEventListener('touchstart', outside, true);
              document.addEventListener('keydown', onKey, true);
            };
          }

          if (dd.open) {
            dd.open = false;
          } else {
            dd.open = true;
            dd.__bindClose && dd.__bindClose();
          }
        }
    
    // Style the toggle button for proper alignment
    toggleButton.style.display = 'flex';
    toggleButton.style.alignItems = 'center';
    toggleButton.style.gap = '6px';
    toggleButton.style.position = 'relative';
    
    normalizeGarageToggleButton(toggleButton);

    // Remove any stray icon elements Convermax/theme may place outside the toggle button.
    try {
      const stray = widgetRoot.querySelectorAll(
        '.icon-garage:not(.cm_toggle-dropdown .icon-garage):not(.garage-button .icon-garage), .cm_icon_garage__background, .garage-icon, [class*="cm_icon"]'
      );
      stray.forEach((n) => {
        if (!n || n.nodeType !== 1) return;
        if (toggleButton && (toggleButton === n || toggleButton.contains(n))) return;
        try { n.remove(); } catch (e) {}
      });
    } catch (e) {}

    const garageLabel = widgetRoot.querySelector('.garage-label') || toggleButton.querySelector('.header-icon-text');
    if (garageLabel) {
      garageLabel.className = 'header-icon-text';
      garageLabel.textContent = 'My Garage';
    }
    
    const applyDialogStyles = function() {
      const dialog = document.querySelector('.dialog-container');
      if (dialog && !dialog.hasAttribute('data-styled')) {
        // Check if this is a YMM dialog (not filters)
        const hasYMMWidget = dialog.querySelector('.cm_vehicle-widget');
        const hasFilters = dialog.querySelector('.cm_FacetPanel');
        
        // Only apply black theme to YMM dialogs, skip filters
        if (hasFilters && !hasYMMWidget) {
          return; // Skip styling for filters dialog
        }
        
        dialog.setAttribute('data-styled', 'true');
        dialog.style.cssText = (dialog.style.cssText || '') + ';opacity: 0 !important; visibility: hidden !important;';

        if (!dialog.__visibilityGuard) {
          const guard = new MutationObserver(function() {
            if (!dialog.classList.contains('dialog-ready')) {
              dialog.style.opacity = '0';
              dialog.style.visibility = 'hidden';
            }
          });
          guard.observe(dialog, { attributes: true, attributeFilter: ['style', 'class'] });
          dialog.__visibilityGuard = guard;
        }

        setTimeout(function() {
          const allRows = dialog.querySelectorAll('.cm_row');
          allRows.forEach(row => {
            row.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          });
          
          const row = dialog.querySelector('.cm_vehicle-widget__row');
          if (row) row.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          dialog.style.cssText = 'background: #000000 !important; background-color: #000000 !important; border: 1px solid #ffffff !important; border-radius: 8px !important; padding: 20px !important;';
          
          const dialogContent = dialog.querySelector('.dialog-content');
          if (dialogContent) dialogContent.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const dialogBody = dialog.querySelector('.dialog-body');
          if (dialogBody) dialogBody.style.cssText = 'background: #000000 !important; background-color: #000000 !important; color: #ffffff !important;';
          
          const widget = dialog.querySelector('.cm_vehicle-widget');
          if (widget) widget.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const dropdowns = dialog.querySelector('.cm_vehicle-widget_dropdowns');
          if (dropdowns) dropdowns.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const widgetBody = dialog.querySelector('.cm_vehicle-widget_body');
          if (widgetBody) widgetBody.style.cssText = 'background: #000000 !important; background-color: #000000 !important;';
          
          const closeBtn = dialog.querySelector('.close');
          if (closeBtn) {
            closeBtn.style.cssText = 'position: absolute; top: 15px; right: 15px; color: #ffffff; cursor: pointer; z-index: 1000; background: #000000; padding: 5px; border-radius: 4px;';
            const closeSvg = closeBtn.querySelector('svg');
            if (closeSvg) closeSvg.style.stroke = '#ffffff';
          }
          
          const title = dialog.querySelector('.cm_vehicle-widget_title');
          if (title) title.style.color = '#ffffff';
          
          const goBtn = dialog.querySelector('.cm_vehicle-widget_button__go');
          if (goBtn) {
            goBtn.style.cssText = 'background: #da2625 !important; color: #ffffff !important; border: 1px solid #ffffff !important;';
          }
          
          const clearBtn = dialog.querySelector('.cm_vehicle-widget_button__clear');
          if (clearBtn) {
            clearBtn.style.cssText = 'background: #000000 !important; color: #ffffff !important; border: 1px solid #ffffff !important;';
            const clearSvg = clearBtn.querySelector('svg');
            if (clearSvg) clearSvg.style.fill = '#ffffff';
          }

          try {
            const wrappers = dialog.querySelectorAll('.cm_vehicle-widget_select, .cm_select');
            wrappers.forEach(w => {
              const label = w.querySelector('label, .cm_select_label, .cm_vehicle-widget_select-label');
              const text = (label ? label.textContent : w.textContent) || '';
              if (/sub\s*model/i.test(text)) {
                w.style.display = 'none';
              }
              const selects = w.querySelectorAll('select');
              selects.forEach(sel => {
                const id = sel.id || '';
                const name = sel.name || '';
                const cls = sel.className || '';
                if (/submodel|sub\-?model|submod/i.test(id + ' ' + name + ' ' + cls)) {
                  w.style.display = 'none';
                }
              });
            });
            const ordered = dialog.querySelectorAll('.cm_vehicle-widget_select');
            if (ordered && ordered.length >= 4) {
              const fourth = ordered[3];
              if (fourth) fourth.style.display = 'none';
            }
          } catch(e) {}
          
          if (dialog.__visibilityGuard) {
            dialog.__visibilityGuard.disconnect();
            dialog.__visibilityGuard = null;
          }
          dialog.classList.add('dialog-ready');
          const overlay = document.querySelector('.dialog-overlay');
          if (overlay) overlay.classList.add('dialog-ready');
          const backdrop = document.querySelector('.dialog-backdrop');
          if (backdrop) backdrop.classList.add('dialog-ready');
          
          const dialogCloseBtn = dialog.querySelector('.close');
          if (dialogCloseBtn && !dialogCloseBtn.__syncBound) {
            dialogCloseBtn.addEventListener('click', function() {
              setTimeout(syncConvermaxToYMM, 500);
            });
            dialogCloseBtn.__syncBound = true;
          }
        }, 30);
      }
    };
    
    const dialogObserver = new MutationObserver(function(mutations) {
      applyDialogStyles();
    });
    
    dialogObserver.observe(document.body, { childList: true, subtree: true });
    
    const syncConvermaxToYMM = function() {
      try {
        let year, make, model;
        
        const garageEl = document.querySelector('#cm-garage');
        if (garageEl) {
          const badge = garageEl.querySelector('.garage-size');
          const badgeText = badge ? badge.textContent.trim() : '';
          
          if (badgeText && badgeText !== '0') {
            const dropdown = garageEl.querySelector('.dropdown-content, .cm_dropdown-content');
            if (dropdown) {
              const items = dropdown.querySelectorAll('.garage-item, .cm_garage-item, [class*="vehicle"]');
              if (items.length > 0) {
                const firstItem = items[0];
                const text = firstItem.textContent || firstItem.innerText || '';
                const match = text.match(/(\d{4})\s+([^\s]+)\s+(.+)/);
                if (match) {
                  year = match[1];
                  make = match[2];
                  model = match[3].trim();
                }
              }
            }
          }
        }
        
        if (!year || !make || !model) {
          for (let key in localStorage) {
            if (key.includes('convermax') || key.includes('cm_') || key.includes('CMVehicle')) {
              try {
                const data = JSON.parse(localStorage.getItem(key));
                if (data && data.year && data.make && data.model) {
                  year = data.year;
                  make = data.make;
                  model = data.model;
                  break;
                }
              } catch(e) {}
            }
          }
        }
        
        if (!year || !make || !model) {
          const cookies = document.cookie.split(';');
          for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name.includes('cm_') || name.includes('convermax') || name.includes('vehicle')) {
              try {
                const data = JSON.parse(decodeURIComponent(value));
                if (data && data.year && data.make && data.model) {
                  year = data.year;
                  make = data.make;
                  model = data.model;
                  break;
                }
              } catch(e) {}
            }
          }
        }
        
        if (year && make && model) {
          const storage = {
            set: function(key, value, expiryDays = 1) {
              const expiry = expiryDays ? Date.now() + expiryDays * 24 * 60 * 60 * 1000 : null;
              const item = JSON.stringify({ value, expiry });
              localStorage.setItem(key, item);
            }
          };
          
          storage.set('ymm-year', year.toString());
          storage.set('ymm-make', make);
          storage.set('ymm-model', model);
          
          const event = new CustomEvent('ymmUpdated', { 
            detail: { year, make, model } 
          });
          document.dispatchEvent(event);
          
          return true;
        }
        return false;
      } catch(e) {
        return false;
      }
    };
    
    const cookieObserver = setInterval(syncConvermaxToYMM, 1000);
    syncConvermaxToYMM();
    
    if (firstRun) {
      garage.style.opacity = '1';
      garage.style.visibility = 'visible';
      garage.classList.add('garage-ready');
      garage.setAttribute('data-custom-processed', 'true');
      isProcessing = false;
    }
  }

  function removeConvermaxIcon() {
    const garages = getGarageContainers();
    if (!garages.length) return;
    garages.forEach((g) => processGarageContainer(g));
    hideDuplicateVisibleGarages();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeConvermaxIcon);
  } else {
    removeConvermaxIcon();
  }
  
  const observer = new MutationObserver(function(mutations) {
    if (isProcessing) return;

    const garages = getGarageContainers();
    if (!garages.length) return;

    let needsFix = false;
    garages.forEach((garage) => {
      const toggleButton = garage.querySelector('.cm_garage .cm_toggle-dropdown, .cm_garage .garage-button, .cm_toggle-dropdown, .garage-button, a, button');
      const customCount = toggleButton ? toggleButton.querySelectorAll('.icon-garage').length : 0;
      const hasConvermaxIcon = toggleButton ? !!toggleButton.querySelector('.cm_icon_garage__background, .garage-icon, [class*="cm_icon"]') : false;
      if (!garage.hasAttribute('data-custom-processed') || customCount !== 1 || hasConvermaxIcon) {
        needsFix = true;
      }
    });

    if (needsFix) removeConvermaxIcon();
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();



// // Convert SKU to UPC for SET and WHEEL AND TIRE PACKAGE products
// (function() {
//   function convertSkuToUpc() {
//     const skuContainers = document.querySelectorAll('.cm_product-item__sku-container:not([data-processed])');
    
//     skuContainers.forEach(container => {
//       const skuTitle = container.querySelector('.sku-title');
//       const skuValue = container.querySelector('.sku-value');
      
//       if (!skuTitle || !skuValue) return;
      
//       container.setAttribute('data-processed', 'true');
      
//       const skuText = skuValue.textContent.trim();
      
//       if (skuText.startsWith('SET-')) {
//         skuTitle.textContent = 'UPC: ';
//         return;
//       }
      
//       const productItem = container.closest('.cm_product-item, .cm_product-item__details')?.parentElement;
//       const productTitle = productItem?.querySelector('.cm_product-item__title')?.textContent?.toLowerCase() || '';
      
//       const hasWheel = productTitle.includes('wheel');
//       const hasTire = productTitle.includes('tire');
      
//       if (hasWheel && hasTire) {
//         skuTitle.textContent = 'UPC: ';
//       } else if (hasTire && !hasWheel) {
//         container.style.display = 'none';
//       }
//     });
//   }
  
//   const observer = new MutationObserver(function(mutations) {
//     let hasNewSku = false;
//     for (let mutation of mutations) {
//       if (mutation.addedNodes.length) {
//         for (let node of mutation.addedNodes) {
//           if (node.nodeType === 1) {
//             if (node.classList?.contains('cm_product-item__sku-container') || 
//                 node.querySelector?.('.cm_product-item__sku-container')) {
//               hasNewSku = true;
//               break;
//             }
//           }
//         }
//       }
//       if (hasNewSku) break;
//     }
//     if (hasNewSku) convertSkuToUpc();
//   });
  
//   function startObserving() {
//     if (document.body) {
//       observer.observe(document.body, {
//         childList: true,
//         subtree: true
//       });
//       setTimeout(convertSkuToUpc, 500);
//       setTimeout(convertSkuToUpc, 1500);
//     }
//   }
  
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', startObserving);
//   } else {
//     startObserving();
//   }
// })();


// Hide Convermax SKU containers (we show UPC via barcode fetch instead)
// and fetch real barcode/UPC + stock status from Shopify product API
(function() {
  var productCache = {};

  var ICON_INSTOCK = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.11111 0.388916C3.1842 0.388916 0 3.57311 0 7.50003C0 11.4269 3.1842 14.6111 7.11111 14.6111C11.038 14.6111 14.2222 11.4269 14.2222 7.50003C14.2222 3.57311 11.038 0.388916 7.11111 0.388916ZM10.961 6.96472L7.40543 10.5203C7.16049 10.7652 6.84049 10.8877 6.51852 10.8877C6.2242 10.8877 5.92988 10.785 5.69284 10.5776L3.32247 8.50348C2.80099 8.04719 2.74765 7.25509 3.20395 6.73361C3.66025 6.21213 4.45235 6.15879 4.97383 6.61509L6.46124 7.91682L9.18716 5.19089C9.67704 4.70101 10.4711 4.70101 10.961 5.19089C11.4509 5.68077 11.4509 6.47484 10.961 6.96472Z" fill="#19C98A"/></svg>';
  var ICON_OUTSTOCK = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.11C0 3.1837 3.1837 0 7.11 0C11.0363 0 14.22 3.1837 14.22 7.11C14.22 11.0363 11.0363 14.22 7.11 14.22C3.1837 14.22 0 11.0363 0 7.11ZM8.58721 7.10967L10.6294 5.06595L10.6312 5.06508C10.8272 4.86911 10.9373 4.60332 10.9373 4.32617C10.9373 4.04903 10.8272 3.78324 10.6312 3.58727C10.4352 3.3913 10.1693 3.28121 9.89217 3.28121C9.615 3.28121 9.34918 3.3913 9.15318 3.58727L7.10923 5.63186L5.06702 3.58814C4.87103 3.39217 4.60521 3.28208 4.32803 3.28208C4.05086 3.28208 3.78503 3.39217 3.58904 3.58814C3.39305 3.78411 3.28294 4.0499 3.28294 4.32704C3.28294 4.46427 3.30998 4.60015 3.3625 4.72693C3.41502 4.85372 3.492 4.96891 3.58904 5.06595L5.63126 7.10967L3.5873 9.15426C3.39131 9.35023 3.28121 9.61602 3.28121 9.89316C3.28121 10.1703 3.39131 10.4361 3.5873 10.6321C3.7833 10.828 4.04912 10.9381 4.32629 10.9381C4.60347 10.9381 4.86929 10.828 5.06528 10.6321L7.10923 8.58748L9.15405 10.6312C9.35005 10.8272 9.61587 10.9373 9.89304 10.9373C10.1702 10.9373 10.436 10.8272 10.632 10.6312C10.828 10.4352 10.9381 10.1694 10.9381 9.89229C10.9381 9.61515 10.828 9.34936 10.632 9.15339L8.58721 7.10967Z" fill="#F44336"/></svg>';

  function hideSkuContainers() {
    document.querySelectorAll('.cm_product-item__sku-container:not([data-processed])').forEach(function(c) {
      c.setAttribute('data-processed', 'true');
      c.style.display = 'none';
    });
  }

  function createStockLine(inStock) {
    var line = document.createElement('div');
    line.className = 'line-store-avaialble flex align-items-center';
    line.style.cssText = 'display:flex;align-items:center;gap:6px;margin-bottom:3px;font-size:13px;';
    var icon = document.createElement('span');
    icon.style.cssText = 'flex:0 0 15px;max-width:15px;line-height:0;';
    icon.innerHTML = inStock ? ICON_INSTOCK : ICON_OUTSTOCK;
    var text = document.createElement('span');
    text.textContent = inStock ? 'In Stock' : 'Out of Stock';
    line.appendChild(icon);
    line.appendChild(text);
    return line;
  }

  function applyProductData(card, data) {
    var detailsEl = card.querySelector('.cm_product-item__details');
    if (!detailsEl) return;
    var titleEl = detailsEl.querySelector('.cm_product-item__title');
    if (!titleEl) return;

    // Inject UPC above title
    var barcode = '';
    if (data.variants && data.variants.length) {
      barcode = data.variants[0].barcode || '';
    }
    if (barcode && /^\d+$/.test(barcode.trim())) {
      var upcEl = document.createElement('p');
      upcEl.className = 'product-sku product-upc cm-upc-label';
      upcEl.style.cssText = 'margin:0 0 2px;color:#888;font-size:13px;font-weight:400;';
      upcEl.textContent = 'UPC ' + barcode.trim();
      titleEl.parentNode.insertBefore(upcEl, titleEl);
    }

    // Inject stock status after title
    var stockWrapper = document.createElement('div');
    stockWrapper.className = 'product-inventory cm-stock-status';
    stockWrapper.style.cssText = 'margin:6px 0 4px;';
    stockWrapper.appendChild(createStockLine(data.available));

    // Insert after title
    if (titleEl.nextSibling) {
      titleEl.parentNode.insertBefore(stockWrapper, titleEl.nextSibling);
    } else {
      titleEl.parentNode.appendChild(stockWrapper);
    }
  }

  function injectProductData() {
    var cards = document.querySelectorAll('.cm_product-item:not([data-cm-enriched])');
    if (!cards.length) return;

    cards.forEach(function(card) {
      card.setAttribute('data-cm-enriched', 'true');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      var match = href.match(/\/products\/([^?#]+)/);
      if (!match) return;
      var handle = match[1];

      if (productCache[handle]) {
        applyProductData(card, productCache[handle]);
        return;
      }

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          productCache[handle] = data;
          applyProductData(card, data);
        })
        .catch(function() {});
    });
  }

  function processCards() {
    hideSkuContainers();
    injectProductData();
    // Trigger sale-label enrichment after cards are enriched (Notion #412)
    if (window.__saleLabelEnrich) {
      clearTimeout(window.__saleLabelEnrichTimeout);
      window.__saleLabelEnrichTimeout = setTimeout(window.__saleLabelEnrich, 800);
    }
    // Trigger custom-card-label enrichment after cards are enriched (Notion #423)
    if (window.__cardLabelEnrich) {
      clearTimeout(window.__cardLabelEnrichTimeout);
      window.__cardLabelEnrichTimeout = setTimeout(window.__cardLabelEnrich, 800);
    }
  }

  var observer = new MutationObserver(function(mutations) {
    var hasNewCards = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1) {
            if (node.classList && (node.classList.contains('cm_product-item') ||
                node.classList.contains('cm_product-item__sku-container')) ||
                (node.querySelector && (node.querySelector('.cm_product-item') ||
                node.querySelector('.cm_product-item__sku-container')))) {
              hasNewCards = true;
              break;
            }
          }
        }
      }
      if (hasNewCards) break;
    }
    if (hasNewCards) processCards();
  });

  function startObserving() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(processCards, 500);
      setTimeout(processCards, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();


// Hide Affirm financing on Convermax product results
(function() {
  function hideAffirm() {
    const affirmElements = document.querySelectorAll('.cm_product-item .affirm-as-low-as, .cm_results-products .affirm-as-low-as, [class*="cm_product"] .affirm-as-low-as');
    affirmElements.forEach(el => {
      el.style.display = 'none';
    });
  }
  
  const affirmObserver = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.querySelector?.('.affirm-as-low-as')) {
            hideAffirm();
            break;
          }
        }
      }
    }
  });
  
  function startAffirmHiding() {
    if (document.body) {
      affirmObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(hideAffirm, 500);
      setTimeout(hideAffirm, 1500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAffirmHiding);
  } else {
    startAffirmHiding();
  }
})();

// Hook YMM clear buttons to also clear ConverMax facet filters
(function() {
  document.addEventListener('click', function(e) {
    // "Clear All" button in sidebar filter
    if (e.target.closest('.clear-all-btn')) {
      if (window.Convermax && window.Convermax.clearCurrentRequest) {
        window.Convermax.clearCurrentRequest(true); // true = preserve vehicle selection
      }
    }
    // YMM "CLEAR" button in the ConverMax vehicle widget bar
    if (e.target.closest('.cm_vehicle-widget_button__clear')) {
      if (window.Convermax && window.Convermax.clearCurrentRequest) {
        window.Convermax.clearCurrentRequest(false); // false = clear everything including vehicle
      }
    }
  });
})();

// HIDE VARIANTS AND SHOW MAIN PRODUCTS

// (function() {
//   const titleCache = new Map(); // handle -> Promise<string|null>
//   const maxConcurrentFetches = 4;
//   let activeFetches = 0;
//   const fetchQueue = [];

//   function runQueuedFetches() {
//     while (activeFetches < maxConcurrentFetches && fetchQueue.length) {
//       const next = fetchQueue.shift();
//       if (typeof next === 'function') next();
//     }
//   }

//   function enqueueFetch(fn) {
//     fetchQueue.push(fn);
//     runQueuedFetches();
//   }

//   function getHandleFromHref(href) {
//     try {
//       const url = new URL(href, window.location.origin);
//       const match = url.pathname.match(/\/products\/([^\/]+)/i);
//       return match ? match[1] : null;
//     } catch (e) {
//       return null;
//     }
//   }

//   function looksLikeVariantLink(href) {
//     try {
//       const url = new URL(href, window.location.origin);
//       return url.searchParams.has('variant');
//     } catch (e) {
//       return /\bvariant=\d+/.test(String(href || ''));
//     }
//   }

//   function fetchProductTitle(handle) {
//     if (!handle) return Promise.resolve(null);
//     if (titleCache.has(handle)) return titleCache.get(handle);

//     const p = new Promise((resolve) => {
//       enqueueFetch(() => {
//         activeFetches++;
//         fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
//           .then(r => (r && r.ok ? r.json() : null))
//           .then(data => {
//             const title = data && data.title ? String(data.title) : null;
//             resolve(title);
//           })
//           .catch(() => resolve(null))
//           .finally(() => {
//             activeFetches--;
//             runQueuedFetches();
//           });
//       });
//     });

//     titleCache.set(handle, p);
//     return p;
//   }

//   function applyBaseTitleToCard(titleLink, baseTitle) {
//     if (!titleLink || !baseTitle) return;
//     titleLink.textContent = baseTitle;
//     titleLink.setAttribute('data-cm-base-title', '1');
//     try { titleLink.setAttribute('title', baseTitle); } catch (e) {}

//     const card = titleLink.closest('.cm_product-item');
//     if (card) {
//       card.setAttribute('data-cm-base-title', '1');
//       const img = card.querySelector('img.cm_product-item__image');
//       if (img) {
//         try { img.alt = baseTitle; } catch (e) {}
//         try { img.setAttribute('title', baseTitle); } catch (e) {}
//       }
//     }
//   }

//   function normalizeConvermaxTitles() {
//     const scope = document.querySelector('.cm_results-products, .cm-results-products, .cm_SearchResults, .cm-search-results, #cm-collection-page, .cm-collection-page') || document;
//     const titleLinks = scope.querySelectorAll('a.cm_product-item__title:not([data-cm-base-title])');

//     titleLinks.forEach((a) => {
//       const href = a.getAttribute('href') || a.href || '';
//       if (!href || !href.includes('/products/')) return;
//       if (!looksLikeVariantLink(href)) return; // only touch variant-targeted cards

//       const handle = getHandleFromHref(href);
//       if (!handle) return;

//       // Mark as in-progress to avoid duplicate work.
//       a.setAttribute('data-cm-base-title', 'loading');

//       fetchProductTitle(handle).then((baseTitle) => {
//         if (!baseTitle) {
//           a.removeAttribute('data-cm-base-title');
//           return;
//         }
//         applyBaseTitleToCard(a, baseTitle);
//       });
//     });
//   }

//   const observer = new MutationObserver(() => {
//     // Debounce via microtask
//     Promise.resolve().then(normalizeConvermaxTitles);
//   });

//   function start() {
//     normalizeConvermaxTitles();
//     if (document.body) {
//       observer.observe(document.body, { childList: true, subtree: true });
//     }
//     setTimeout(normalizeConvermaxTitles, 500);
//     setTimeout(normalizeConvermaxTitles, 1500);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', start);
//   } else {
//     start();
//   }
// })();
/**
 * Convermax Filter +/- Icon Toggle
 * Replaces arrow icons with +/- symbols that change on expand/collapse
 */

(function() {
  'use strict';

  //  allow scrolling inside the Filters dialog when facets expand.
  (function ensureConvermaxFacetDialogScrollStyles() {
    const id = 'cm-facetdialog-scroll-fix';
    if (document.getElementById(id)) return;

    const s = document.createElement('style');
    s.id = id;
    s.textContent = `
      @media (max-width: 768px) {
        /* Ensure the dialog takes the full viewport height and scrolls internally */
        #cm_FacetDialog,
        #cm_FacetDialog .dialog-container,
        #cm_FacetDialog .dialog-content {
          height: 100dvh !important;
          max-height: 100dvh !important;
        }

        #cm_FacetDialog .dialog-container,
        #cm_FacetDialog .dialog-content {
          display: flex !important;
          flex-direction: column !important;
          overflow: hidden !important;
        }

        #cm_FacetDialog .dialog-header,
        #cm_FacetDialog .buttons-container {
          flex: 0 0 auto !important;
        }

        #cm_FacetDialog .dialog-body {
          flex: 1 1 auto !important;
          overflow-y: auto !important;
          -webkit-overflow-scrolling: touch !important;
          overscroll-behavior: contain;
          touch-action: pan-y;
        }
      }
    `;
    (document.head || document.documentElement).appendChild(s);
  })();


  (function ensureConvermaxFacetDialogClosesOnDesktop() {
    if (window.__cmFacetDialogResizeCleanupBound) return;
    window.__cmFacetDialogResizeCleanupBound = true;

    const desktopMq = window.matchMedia('(min-width: 769px)');
    let resizeTimer = null;

    function isVisible(el) {
      if (!el || el.nodeType !== 1) return false;
      try {
        const cs = window.getComputedStyle(el);
        if (!cs) return false;
        if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
        const r = el.getBoundingClientRect();
        return !!(r && r.width > 0 && r.height > 0);
      } catch (_) {
        return false;
      }
    }

    function removeForcedDisplayForMobile() {
      const dlg = document.getElementById('cm_FacetDialog');
      if (!dlg) return;
      try {
        // Remove any forced inline display overrides we may have applied.
        dlg.style.removeProperty('display');
      } catch (_) {}
    }

    function closeFacetDialogForDesktop() {
      const dlg = document.getElementById('cm_FacetDialog');
      if (!dlg) return;
      if (!isVisible(dlg)) return;

      // Prefer clicking Convermax's close button so internal state stays consistent.
      const closeBtn =
        dlg.querySelector('.dialog-header .close') ||
        dlg.querySelector('.close') ||
        dlg.querySelector('[data-cm-role="close"]');

      try {
        if (closeBtn && typeof closeBtn.click === 'function') {
          closeBtn.click();
        }
      } catch (_) {}

      // Fallback: hide the dialog if it remains visible.
      window.setTimeout(() => {
        if (!isVisible(dlg)) return;
        try {
          dlg.style.setProperty('display', 'none', 'important');
        } catch (_) {}
      }, 50);
    }

    function handleChange() {
      if (desktopMq.matches) {
        // Mobile -> desktop
        closeFacetDialogForDesktop();
        window.setTimeout(closeFacetDialogForDesktop, 200);
      } else {
        // Desktop -> mobile
        removeForcedDisplayForMobile();
      }
    }

    try {
      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', handleChange);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(handleChange);
      }
    } catch (_) {}

    window.addEventListener(
      'resize',
      function() {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(handleChange, 100);
      },
      { passive: true }
    );

    // Run once on load.
    handleChange();
  })();

  
  // --- Facet collapse/expand state management ---
  // CSS in convermax-custom.css collapses all facet bodies by default.
  // We track which facets the user has manually opened via the openFacets Set.
  // After Convermax re-renders (filter selection), we re-apply the state.

  const openFacets = new Set();

  function getFacetFieldId(facetholder) {
    const match = facetholder.className.match(/cm_field-[\w-]+/);
    return match ? match[0] : null;
  }

  function applyFacetState() {
    const holders = document.querySelectorAll('.cm_Facets .facetholder, .cm_FacetPanel .facetholder');
    holders.forEach(function(holder) {
      const fieldId = getFacetFieldId(holder);
      if (!fieldId) return;
      if (openFacets.has(fieldId)) {
        holder.classList.add('cm-filter-open');
      } else {
        holder.classList.remove('cm-filter-open');
      }
    });
    updateFilterIcons();
  }

  function updateFilterIcons() {
    const filterHolders = document.querySelectorAll('.cm_Facets .facetholder, .cm_FacetPanel .facetholder');

    filterHolders.forEach(function(holder) {
      const title = holder.querySelector('.facettitle');
      const body = holder.querySelector('.facetbody');

      if (!title || !body) return;

      // Hide Convermax default SVG icons
      const allSvgs = title.querySelectorAll('svg');
      allSvgs.forEach(function(svg) {
        svg.style.display = 'none';
        svg.style.visibility = 'hidden';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.position = 'absolute';
        svg.style.left = '-9999px';
      });

      const filterTitle = title.textContent.trim();
      if (filterTitle.toLowerCase().includes('shop') && filterTitle.toLowerCase().includes('wheel')) {
        return;
      }

      let iconSpan = title.querySelector('.filter-toggle-icon');
      if (!iconSpan) {
        iconSpan = document.createElement('span');
        iconSpan.className = 'filter-toggle-icon';
        iconSpan.style.width = '12px';
        iconSpan.style.height = '2px';
        iconSpan.style.backgroundColor = 'rgba(112, 112, 112, 1)';
        iconSpan.style.display = 'block';
        iconSpan.style.position = 'relative';
        iconSpan.style.marginLeft = 'auto';
        iconSpan.style.flexShrink = '0';
        title.appendChild(iconSpan);

        title.style.display = 'flex';
        title.style.alignItems = 'center';
        title.style.justifyContent = 'space-between';
      }

      const isCollapsed = !holder.classList.contains('cm-filter-open');

      iconSpan.innerHTML = '';
      iconSpan.style.width = '12px';
      iconSpan.style.height = '2px';

      if (isCollapsed) {
        const verticalLine = document.createElement('span');
        verticalLine.className = 'vertical-line';
        verticalLine.style.position = 'absolute';
        verticalLine.style.width = '2px';
        verticalLine.style.height = '12px';
        verticalLine.style.backgroundColor = 'rgba(112, 112, 112, 1)';
        verticalLine.style.left = '5px';
        verticalLine.style.top = '-5px';
        iconSpan.appendChild(verticalLine);
      }
    });
  }

  function init() {
    applyFacetState();

    // MutationObserver: re-apply state after Convermax re-renders
    var debounceTimer = null;
    const observer = new MutationObserver(function(mutations) {
      var needsUpdate = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes.length > 0) {
          needsUpdate = true;
          break;
        }
        if (m.type === 'attributes' && m.attributeName === 'style') {
          needsUpdate = true;
          break;
        }
      }
      if (needsUpdate) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyFacetState, 30);
      }
    });

    const facetsContainer = document.querySelector('.cm_Facets, .cm_FacetPanel');
    if (facetsContainer) {
      observer.observe(facetsContainer, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true,
        childList: true
      });
    }

    // Capture-phase click handler to manage open/close state
    document.addEventListener('click', function(e) {
      const facetTitle = e.target.closest('.facettitle');
      if (!facetTitle) return;

      const holder = facetTitle.closest('.facetholder');
      if (!holder) return;

      // Skip mobile dialog — facets are always expanded there
      if (holder.closest('#cm_FacetDialog') || holder.closest('.cm_dialog')) return;

      const fieldId = getFacetFieldId(holder);
      if (!fieldId) return;

      // Toggle user open/close state
      if (openFacets.has(fieldId)) {
        openFacets.delete(fieldId);
        holder.classList.remove('cm-filter-open');
      } else {
        openFacets.add(fieldId);
        holder.classList.add('cm-filter-open');
      }

      // Prevent Convermax's own toggle from fighting our state
      e.stopPropagation();
      e.preventDefault();

      updateFilterIcons();
    }, true); // capture phase
  }

  function waitForConvermax() {
    const facetsSelector = '.cm_Facets, .cm_FacetPanel, .facetholder';

    if (document.querySelector(facetsSelector)) {
      init();
    } else {
      const loadObserver = new MutationObserver(function() {
        if (document.querySelector(facetsSelector)) {
          loadObserver.disconnect();
          init();
        }
      });

      loadObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForConvermax);
  } else {
    waitForConvermax();
  }
})();


// Merge custom_style facet values into "Model / Style" (oew_style) and hide custom_style.
(function() {
  function textOf(el) {
    return (el && el.textContent ? String(el.textContent).trim() : '');
  }

  function normKey(s) {
    return String(s || '').trim().toLowerCase();
  }

  function rewriteVisibleCustomStyleLabels() {
    const pattern = /\bcustom[\s_\-]*style(s)?\b/i;
    const roots = Array.from(
      document.querySelectorAll(
        '.cm_SearchHeader, .cm_SearchResults, .cm_results-products, .cm-results-products, .cm_Facets, .cm_FacetPanel, #cm-collection-page, .dialog-container'
      )
    );
    if (!roots.length) roots.push(document.body || document.documentElement);

    roots.forEach((root) => {
      if (!root) return;

      const candidates = root.querySelectorAll(
        [
          'button',
          'a',
          '[role="button"]',
          '[class*="facet"]',
          '[class*="Facet"]',
          '[class*="filter"]',
          '[class*="Filter"]',
          '[class*="crumb"]',
          '[class*="Crumb"]'
        ].join(',')
      );

      candidates.forEach((el) => {
        if (!el || el.nodeType !== 1) return;
        if (el.getAttribute('data-cm-custom-style-label-fixed') === '1') return;

        const t = textOf(el);
        const aria = el.getAttribute('aria-label') || '';
        const title = el.getAttribute('title') || '';

        // Only touch elements that actually mention the field name.
        const mentions = pattern.test(t) || pattern.test(aria) || pattern.test(title);
        if (!mentions) return;

        // Avoid rewriting the actual facet list title/heading if it somehow leaks through.
        if (el.closest && el.closest('.facetholder.cm_field-custom_style')) return;

        try {
          if (t && pattern.test(t)) {
            el.textContent = t.replace(pattern, 'Model / Style');
          }
          if (aria && pattern.test(aria)) {
            el.setAttribute('aria-label', aria.replace(pattern, 'Model / Style'));
          }
          if (title && pattern.test(title)) {
            el.setAttribute('title', title.replace(pattern, 'Model / Style'));
          }
          el.setAttribute('data-cm-custom-style-label-fixed', '1');
        } catch (e) {}
      });
    });
  }

  function rewriteVisibleCustomSeriesLabels() {
    const pattern = /\bcustom[\s_\-]*series\b/i;
    const roots = Array.from(
      document.querySelectorAll(
        '.cm_SearchHeader, .cm_SearchResults, .cm_results-products, .cm-results-products, .cm_Facets, .cm_FacetPanel, #cm-collection-page, .dialog-container'
      )
    );
    if (!roots.length) roots.push(document.body || document.documentElement);

    roots.forEach((root) => {
      if (!root) return;

      const candidates = root.querySelectorAll(
        [
          'button',
          'a',
          '[role="button"]',
          '[class*="facet"]',
          '[class*="Facet"]',
          '[class*="filter"]',
          '[class*="Filter"]',
          '[class*="crumb"]',
          '[class*="Crumb"]'
        ].join(',')
      );

      candidates.forEach((el) => {
        if (!el || el.nodeType !== 1) return;
        if (el.getAttribute('data-cm-custom-series-label-fixed') === '1') return;

        const t = textOf(el);
        const aria = el.getAttribute('aria-label') || '';
        const title = el.getAttribute('title') || '';

        const mentions = pattern.test(t) || pattern.test(aria) || pattern.test(title);
        if (!mentions) return;

        if (el.closest && el.closest('.facetholder.cm_field-custom_series')) return;

        try {
          if (t && pattern.test(t)) {
            el.textContent = t.replace(pattern, 'Series');
          }
          if (aria && pattern.test(aria)) {
            el.setAttribute('aria-label', aria.replace(pattern, 'Series'));
          }
          if (title && pattern.test(title)) {
            el.setAttribute('title', title.replace(pattern, 'Series'));
          }
          el.setAttribute('data-cm-custom-series-label-fixed', '1');
        } catch (e) {}
      });
    });
  }

  function hideFacetButKeepInDom(facetEl) {
    if (!facetEl || facetEl.nodeType !== 1) return;
    if (facetEl.getAttribute('data-cm-facet-hidden-offscreen') === '1') return;
    facetEl.setAttribute('data-cm-facet-hidden-offscreen', '1');
    try {
      facetEl.style.setProperty('position', 'absolute', 'important');
      facetEl.style.setProperty('left', '-99999px', 'important');
      facetEl.style.setProperty('top', '0', 'important');
      facetEl.style.setProperty('width', '1px', 'important');
      facetEl.style.setProperty('height', '1px', 'important');
      facetEl.style.setProperty('overflow', 'hidden', 'important');
      facetEl.style.setProperty('opacity', '0', 'important');
      facetEl.style.setProperty('pointer-events', 'none', 'important');
    } catch (e) {}
  }

  function setFacetTitle(facetEl, newTitle) {
    if (!facetEl || facetEl.nodeType !== 1) return;
    const titleSpan = facetEl.querySelector('.facettitle span');
    if (!titleSpan) return;
    const current = textOf(titleSpan);
    if (current === newTitle) return;
    try {
      titleSpan.textContent = newTitle;
    } catch (e) {}
  }

  function showFacetIfHiddenOffscreen(facetEl) {
    if (!facetEl || facetEl.nodeType !== 1) return;
    if (facetEl.getAttribute('data-cm-facet-hidden-offscreen') !== '1') return;
    facetEl.removeAttribute('data-cm-facet-hidden-offscreen');
    try {
      facetEl.style.removeProperty('position');
      facetEl.style.removeProperty('left');
      facetEl.style.removeProperty('top');
      facetEl.style.removeProperty('width');
      facetEl.style.removeProperty('height');
      facetEl.style.removeProperty('overflow');
      facetEl.style.removeProperty('opacity');
      facetEl.style.removeProperty('pointer-events');
    } catch (e) {}
  }

  function findTargetFacet(scopeRoot) {
    const scope = scopeRoot && scopeRoot.querySelector ? scopeRoot : document;
    let target = scope.querySelector('.facetholder.cm_field-oew_style');
    if (target) return target;

    // Fallback: Convermax sometimes changes the field class, but the visible title remains.
    const holders = Array.from(scope.querySelectorAll('.facetholder'));
    const rx = /model\s*\/\s*style|model\s*\-\s*style|model\s+style/i;
    target = holders.find((h) => {
      const t = textOf(h.querySelector('.facettitle span'));
      return t && rx.test(t);
    });
    return target || null;
  }

  function findTargetFacetSeries(scopeRoot) {
    const scope = scopeRoot && scopeRoot.querySelector ? scopeRoot : document;
    let target = scope.querySelector('.facetholder.cm_field-oew_series');
    if (target) return target;

    const holders = Array.from(scope.querySelectorAll('.facetholder'));
    const rx = /^\s*series\s*$/i;
    target = holders.find((h) => {
      const t = textOf(h.querySelector('.facettitle span'));
      return t && rx.test(t);
    });
    return target || null;
  }

  function mergeFromSourceToTarget(opts) {
    const {
      sourceSelector,
      sourceField,
      targetFinder,
      fallbackTitle,
      mergedIntoAttr,
      rewriteLabels,
      combineDuplicateCounts,
      replaceDuplicates
    } = opts;

    // Strategy: never move/remove Convermax-owned facet rows.
    // Instead, create *proxy* rows in the target facet that forward clicks
    // to the original rows in the (hidden) source facet.

    function cssEscapeValue(v) {
      try {
        if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(v));
      } catch (_) {}
      return String(v).replace(/\\/g, '\\\\').replace(/\"/g, '\\"');
    }

    function findEntryByKey(facetEl, keyNorm) {
      if (!facetEl) return null;
      const divs = Array.from(facetEl.querySelectorAll('.facetdiv'));
      return (
        divs.find((d) => {
          const tk = d.querySelector('.facetentrykey');
          return normKey(textOf(tk)) === keyNorm;
        }) || null
      );
    }

    function resetProxyState(targetFacet, sourceFieldLocal) {
      if (!targetFacet) return;
      try {
        const proxies = targetFacet.querySelectorAll(
          '.facetdiv[data-cm-proxy-from="' + sourceFieldLocal + '"]'
        );
        proxies.forEach((p) => {
          try { p.remove(); } catch (_) {}
        });

        const hidden = targetFacet.querySelectorAll(
          '.facetdiv[data-cm-hidden-by-proxy="' + sourceFieldLocal + '"]'
        );
        hidden.forEach((d) => {
          try {
            d.style.removeProperty('display');
            d.removeAttribute('data-cm-hidden-by-proxy');
          } catch (_) {}
        });
      } catch (_) {}
    }

    function createProxyEntry(entry, sourceFacetLocal, sourceFieldLocal, keyNorm) {
      const proxy = entry.cloneNode(true);
      try {
        proxy.setAttribute('data-cm-proxy-from', sourceFieldLocal);
        proxy.setAttribute('data-cm-proxy-key', keyNorm);
      } catch (_) {}

      // Forward interaction to the original entry so Convermax applies the real filter.
      const forward = function(ev) {
        try {
          if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            ev.stopImmediatePropagation && ev.stopImmediatePropagation();
          }
        } catch (_) {}

        const original = findEntryByKey(sourceFacetLocal, keyNorm);
        if (!original) return;

        const clickable =
          original.querySelector('.facetentrykey') ||
          original.querySelector('input.cm_facet_checkbox') ||
          original;

        try {
          if (clickable && typeof clickable.click === 'function') clickable.click();
        } catch (_) {}

        window.setTimeout(() => {
          try {
            const srcCb = original.querySelector('input.cm_facet_checkbox');
            const dstCb = proxy.querySelector('input.cm_facet_checkbox');
            if (srcCb && dstCb) dstCb.checked = !!srcCb.checked;
          } catch (_) {}
        }, 50);
      };

      try {
        proxy.addEventListener('click', forward, true);
        proxy.addEventListener(
          'keydown',
          function(e) {
            const k = e && (e.key || e.code);
            if (k === 'Enter' || k === ' ' || k === 'Spacebar' || k === 'Space') {
              forward(e);
            }
          },
          true
        );
      } catch (_) {}

      // Ensure the proxy label doesn't accidentally say custom_*.
      try {
        const keyEl = proxy.querySelector('.facetentrykey');
        if (keyEl) keyEl.setAttribute('data-cm-proxy', '1');
      } catch (_) {}

      return proxy;
    }

    const sourceFacets = Array.from(document.querySelectorAll(sourceSelector));
    if (!sourceFacets.length) return;

    sourceFacets.forEach((sourceFacet) => {
      if (!sourceFacet || sourceFacet.nodeType !== 1) return;

      const scope =
        sourceFacet.closest('.cm_FacetPanel, .cm_Facets, .dialog-container, .dialog-body') ||
        document;

      const targetFacet = targetFinder(scope);
      if (!targetFacet) {
        setFacetTitle(sourceFacet, fallbackTitle);
        showFacetIfHiddenOffscreen(sourceFacet);
        if (typeof rewriteLabels === 'function') rewriteLabels();
        return;
      }

      if (targetFacet === sourceFacet) {
        setFacetTitle(sourceFacet, fallbackTitle);
        showFacetIfHiddenOffscreen(sourceFacet);
        if (typeof rewriteLabels === 'function') rewriteLabels();
        return;
      }

      const targetContainer =
        targetFacet.querySelector('.facetvalues .cmRepeater_ShowAlwaysValues') ||
        targetFacet.querySelector('.facetvalues') ||
        targetFacet;
      if (!targetContainer) return;

      // Remove old proxies for this merge so reruns stay idempotent.
      resetProxyState(targetFacet, sourceField);

      const existingKeys = new Set(
        Array.from(targetFacet.querySelectorAll('.facetdiv .facetentrykey')).map((k) => normKey(textOf(k)))
      );

      const sourceEntries = Array.from(sourceFacet.querySelectorAll('.facetdiv'));
      if (!sourceEntries.length) {
        hideFacetButKeepInDom(sourceFacet);
        return;
      }

      sourceEntries.forEach((entry) => {
        if (!entry || entry.nodeType !== 1) return;

        const keyEl = entry.querySelector('.facetentrykey');
        const key = normKey(textOf(keyEl));
        if (!key) return;

        // Avoid double-proxying the same key if Convermax happens to retain proxies.
        try {
          const sel =
            '.facetdiv[data-cm-proxy-from="' +
            sourceField +
            '"][data-cm-proxy-key="' +
            cssEscapeValue(key) +
            '"]';
          if (targetFacet.querySelector(sel)) return;
        } catch (_) {}

        if (existingKeys.has(key)) {
          if (replaceDuplicates) {
            try {
              const targetDiv = findEntryByKey(targetFacet, key);
              if (targetDiv && targetDiv.parentNode) {
                const proxy = createProxyEntry(entry, sourceFacet, sourceField, key);
                try {
                  proxy.setAttribute('data-cm-replaced-duplicate', '1');
                } catch (_) {}

                // Insert proxy before the original target row and hide the original.
                targetDiv.parentNode.insertBefore(proxy, targetDiv);
                targetDiv.setAttribute('data-cm-hidden-by-proxy', sourceField);
                targetDiv.style.setProperty('display', 'none', 'important');
              }
            } catch (_) {}
            return;
          }

          if (combineDuplicateCounts) {
            try {
              const sourceValEl = entry.querySelector('.facetentryval');
              const sourceCount = sourceValEl ? parseInt(textOf(sourceValEl), 10) : NaN;
              if (!Number.isNaN(sourceCount)) {
                const targetDiv = findEntryByKey(targetFacet, key);
                if (targetDiv) {
                  const targetValEl = targetDiv.querySelector('.facetentryval');
                  if (targetValEl) {
                    const baseAttr = 'cmBaseCount';
                    const addAttr = 'cmAddedFrom_' + sourceField;

                    let base = parseInt(targetValEl.dataset[baseAttr] || '', 10);
                    if (Number.isNaN(base)) {
                      base = parseInt(textOf(targetValEl), 10);
                      if (Number.isNaN(base)) base = 0;
                      targetValEl.dataset[baseAttr] = String(base);
                    }

                    // Keep this idempotent: always overwrite the added count for this source field.
                    targetValEl.dataset[addAttr] = String(sourceCount);

                    const added = parseInt(targetValEl.dataset[addAttr] || '0', 10) || 0;
                    const total = base + added;
                    targetValEl.textContent = String(total);
                    targetDiv.setAttribute('data-cm-merged-count-from', sourceField);
                  }
                }
              }
            } catch (e) {}
          }
          return;
        }

        const proxy = createProxyEntry(entry, sourceFacet, sourceField, key);
        targetContainer.appendChild(proxy);
        existingKeys.add(key);
      });

      try {
        sourceFacet.setAttribute(mergedIntoAttr, '1');
      } catch (e) {}
      hideFacetButKeepInDom(sourceFacet);
    });

    if (typeof rewriteLabels === 'function') rewriteLabels();
  }

  function mergeFacetValues() {
    mergeFromSourceToTarget({
      sourceSelector: '.facetholder.cm_field-custom_style',
      sourceField: 'custom_style',
      targetFinder: findTargetFacet,
      fallbackTitle: 'Model / Style',
      mergedIntoAttr: 'data-cm-merged-into-oew-style',
      rewriteLabels: rewriteVisibleCustomStyleLabels
    });

    mergeFromSourceToTarget({
      sourceSelector: '.facetholder.cm_field-custom_series',
      sourceField: 'custom_series',
      targetFinder: findTargetFacetSeries,
      fallbackTitle: 'Series',
      mergedIntoAttr: 'data-cm-merged-into-oew-series',
      rewriteLabels: rewriteVisibleCustomSeriesLabels,
      replaceDuplicates: true
    });
  }

  let debounceTimer = null;
  function scheduleMerge() {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => {
      debounceTimer = null;
      mergeFacetValues();
    }, 50);
  }

  function start() {
    scheduleMerge();
    scheduleMerge();
    window.setTimeout(scheduleMerge, 250);
    window.setTimeout(scheduleMerge, 1000);

    if (!document.body || document.body.__cmMergeCustomStyleObserver) return;
    document.body.__cmMergeCustomStyleObserver = true;
    try {
      const mo = new MutationObserver(() => scheduleMerge());
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function() {
  const style = document.createElement('style');
  style.textContent = `
    /* Banner container above products */
    .collection-banner-container {
      width: 100%;
      margin: 20px 0;
    }
    
    /* Default banner (no vehicle) */
    .default-collection-banner {
      padding: 12px 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    
    .default-collection-banner .banner-text {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: #000;
      margin: 0;
    }
    
    .default-collection-banner .collection-name {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      color: #000;
    }
    
    /* Vehicle banner (green) */
    .vehicle-banner-replacement {
      background-color: rgba(225, 255, 237, 1);
      padding: 12px 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      box-sizing: border-box;
      position: relative;
    }
    
    .vehicle-banner-replacement .check-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
    
    .vehicle-banner-replacement .banner-text {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: #000;
      margin: 0;
    }
    
    .vehicle-banner-replacement .vehicle-name {
      font-family: 'Inter', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      text-transform: uppercase;
      color: #000;
    }
    
    /* Mobile responsive styles */
    @media (max-width: 768px) {
      .collection-banner-container {
        margin: 15px 0;
      }
      
      .default-collection-banner,
      .vehicle-banner-replacement {
        padding: 10px 15px;
        flex-wrap: wrap;
      }
      
      .default-collection-banner .banner-text,
      .vehicle-banner-replacement .banner-text {
        font-size: 16px;
      }
      
      .default-collection-banner .collection-name,
      .vehicle-banner-replacement .vehicle-name {
        font-size: 16px;
      }
      
      .vehicle-banner-replacement .check-icon {
        width: 18px;
        height: 18px;
      }
    }

    @media (max-width: 480px) {
      .default-collection-banner,
      .vehicle-banner-replacement {
        padding: 8px 12px;
      }
      
      .default-collection-banner .banner-text,
      .vehicle-banner-replacement .banner-text {
        font-size: 14px;
      }
      
      .default-collection-banner .collection-name,
      .vehicle-banner-replacement .vehicle-name {
        font-size: 14px;
      }
      
      .vehicle-banner-replacement .check-icon {
        width: 16px;
        height: 16px;
      }
    }
  `;
  document.head.appendChild(style);
  
  function getVehicleInfo() {
    try {
      try {
        if (sessionStorage.getItem('cm_vehicle_cleared') === '1') {
          return null;
        }
      } catch(e) {}

      const urlParams = new URLSearchParams(window.location.search);
      const year = urlParams.get('year');
      const make = urlParams.get('make');
      const model = urlParams.get('model');
      
      if (year && make && model) {
        return {
          year: year,
          make: decodeURIComponent(make).toUpperCase(),
          model: decodeURIComponent(model).toUpperCase()
        };
      }

      // Prefer the *current* YMM selection in the Convermax tabs.
      // This prevents stale sessionStorage (cm_vehicle) from keeping an old vehicle in the banner
      // when the shopper selects a new one on the collection/search page.
      try {
        const root = document.querySelector('#cm-ymm-tabs');
        if (root) {
          const yearSel = root.querySelector('.cm_select_inner-select[aria-label="Year"]');
          const makeSel = root.querySelector('.cm_select_inner-select[aria-label="Make"]');
          const modelSel = root.querySelector('.cm_select_inner-select[aria-label="Model"]');

          const yearVal = yearSel && yearSel.value ? String(yearSel.value).trim() : '';
          const makeVal = makeSel && makeSel.value ? String(makeSel.value).trim() : '';
          const modelVal = modelSel && modelSel.value ? String(modelSel.value).trim() : '';

          const yearText = yearSel && yearSel.selectedOptions && yearSel.selectedOptions[0] ? String(yearSel.selectedOptions[0].textContent || '').trim() : '';
          const makeText = makeSel && makeSel.selectedOptions && makeSel.selectedOptions[0] ? String(makeSel.selectedOptions[0].textContent || '').trim() : '';
          const modelText = modelSel && modelSel.selectedOptions && modelSel.selectedOptions[0] ? String(modelSel.selectedOptions[0].textContent || '').trim() : '';

          const looksLikePlaceholder = (txt) => /^(year|make|model)\b/i.test(txt);

          if (!yearVal || !makeVal || !modelVal || looksLikePlaceholder(yearText) || looksLikePlaceholder(makeText) || looksLikePlaceholder(modelText)) {
            // Not fully selected yet, fall through to other sources.
          } else {
            // Keep sessionStorage in sync so other pages/components can rely on it.
            try {
              sessionStorage.setItem('cm_vehicle', JSON.stringify({ year: yearVal, make: makeVal, model: modelVal }));
              sessionStorage.removeItem('cm_vehicle_cleared');
            } catch(e) {}

            return {
              year: yearVal,
              make: makeVal.toUpperCase(),
              model: modelVal.toUpperCase()
            };
          }
        }
      } catch(e) {}

      // Next, fall back to any stored vehicle.
      const cmVehicle = sessionStorage.getItem('cm_vehicle');
      if (cmVehicle) {
        try {
          const vehicle = JSON.parse(cmVehicle);
          if (vehicle && vehicle.year && vehicle.make && vehicle.model) {
            return {
              year: vehicle.year,
              make: vehicle.make.toUpperCase(),
              model: vehicle.model.toUpperCase()
            };
          }
        } catch(e) {
        }
      }
      
      const garageBadge = document.querySelector('#cm-garage .garage-size');
      if (garageBadge && garageBadge.textContent.trim() !== '0') {
        const dropdown = document.querySelector('#cm-garage .dropdown-content, #cm-garage .cm_dropdown-content');
        if (dropdown) {
          const items = dropdown.querySelectorAll('.garage-item, .cm_garage-item, [class*="vehicle"]');
          if (items.length > 0) {
            const firstItem = items[0];
            const text = firstItem.textContent || firstItem.innerText || '';
            const match = text.match(/(\d{4})\s+([^\s]+)\s+(.+)/);
            if (match) {
              return {
                year: match[1],
                make: match[2].toUpperCase(),
                model: match[3].trim().toUpperCase()
              };
            }
          }
        }
      }
      
      if (window.Convermax && window.Convermax.api && window.Convermax.api.getActiveVehicle) {
        try {
          const activeVehicle = window.Convermax.api.getActiveVehicle();
          if (activeVehicle && activeVehicle.year && activeVehicle.make && activeVehicle.model) {
            return {
              year: activeVehicle.year,
              make: activeVehicle.make.toUpperCase(),
              model: activeVehicle.model.toUpperCase()
            };
          }
        } catch(e) {
        }
      }
      
      const filters = urlParams.get('filter.p.m.oew.year');
      const makeFilter = urlParams.get('filter.p.m.oew.make');
      const modelFilter = urlParams.get('filter.p.m.oew.model');
      if (filters || makeFilter || modelFilter) {
        if (filters && makeFilter && modelFilter) {
          return {
            year: filters,
            make: makeFilter.toUpperCase(),
            model: modelFilter.toUpperCase()
          };
        }
      }
      

      const variantModel = localStorage.getItem('cm_variant-model');
      if (variantModel) {
        try {
          const modelData = JSON.parse(variantModel);
          if (Array.isArray(modelData) && modelData.length >= 3) {
            const vehicleData = {};
            modelData.forEach(item => {
              if (!item) return;
              const field = (item.field || item.name || '').toString().toLowerCase();
              const value = (item.value || item.term || item.label || '').toString();
              if (!value) return;
              if (field === 'year') vehicleData.year = value;
              if (field === 'make') vehicleData.make = value;
              if (field === 'model') vehicleData.model = value;
            });
            if (vehicleData.year && vehicleData.make && vehicleData.model) {
              return {
                year: vehicleData.year,
                make: vehicleData.make.toUpperCase(),
                model: vehicleData.model.toUpperCase()
              };
            }
          }
        } catch(e) {
        }
      }
      
      for (let key in localStorage) {
        if (key.includes('convermax') || key.includes('cm_') || key.includes('CMVehicle')) {
          try {
            const data = JSON.parse(localStorage.getItem(key));
            
            if (key === 'cm_variant-garage' && Array.isArray(data) && data.length > 0) {
            } else {
            }
            
            if (data && data.year && data.make && data.model) {
              return {
                year: data.year,
                make: data.make.toUpperCase(),
                model: data.model.toUpperCase()
              };
            }
          } catch(e) {}
        }
      }
      
      return null;
    } catch(e) {
      return null;
    }
  }
  
  function updateCollectionHeader() {
    let insertTarget = document.querySelector('.cm_SearchHeader');
    
    if (!insertTarget) {
      insertTarget = document.querySelector('.cm-results-products, .cm_results-products, [class*="cm-results"], [class*="products-container"]');
    }
    
    if (!insertTarget) {
      return;
    }
    
    const vehicle = getVehicleInfo();
    
    const header = document.querySelector('h1.cm-collection-header__title, .cm-collection-header__title');
    let displayText = 'Shopping All Wheels';
    let collectionName = 'All Wheels';
    if (header) {
      const originalText = header.textContent.trim();
      collectionName = originalText.replace(/^Shopping\s+/i, '').trim();
      displayText = originalText.toLowerCase().startsWith('shopping') ? originalText : `Shopping ${collectionName}`;
    }
    
    if (vehicle) {
      const defaultBanner = document.querySelector('.default-collection-banner');
      if (defaultBanner) {
        defaultBanner.remove();
      }
      
      const existingBanner = document.querySelector('.vehicle-banner-replacement');
      if (existingBanner) {
        try {
          const vehicleNameEl = existingBanner.querySelector('.vehicle-name');
          if (vehicleNameEl) {
            vehicleNameEl.textContent = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;
          }
        } catch(e) {}
        return;
      }
      
      const bannerHTML = `<div class="collection-banner-container">
          <div class="vehicle-banner-replacement">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM15.535 8.381C15.7145 8.19975 15.9566 8.09397 16.2115 8.08532C16.4665 8.07667 16.7152 8.1658 16.9066 8.33447C17.098 8.50313 17.2177 8.73858 17.2412 8.99262C17.2647 9.24666 17.1902 9.50008 17.033 9.701L16.95 9.795L11.364 15.382C11.1733 15.5726 10.9193 15.6866 10.6502 15.7023C10.381 15.7179 10.1155 15.6342 9.904 15.467L9.808 15.382L7.05 12.624C6.86875 12.4445 6.76297 12.2024 6.75432 11.9475C6.74567 11.6925 6.8348 11.4438 7.00347 11.2524C7.17213 11.061 7.40758 10.9413 7.66162 10.9178C7.91566 10.8943 8.16908 10.9688 8.37 11.126L8.464 11.21L10.586 13.331L15.536 8.381H15.535Z" fill="#00E65C"/>
            </svg>
            <p class="banner-text">
              Wheels that fit your <span class="vehicle-name">${vehicle.year} ${vehicle.make} ${vehicle.model}</span>
            </p>
          </div>
        </div>`;
      
      insertTarget.insertAdjacentHTML('beforebegin', bannerHTML);
      
    } else {
      const vehicleBanner = document.querySelector('.vehicle-banner-replacement');
      if (vehicleBanner) {
        const container = vehicleBanner.closest('.collection-banner-container');
        if (container) container.remove();
      }
      
      const existingDefaultBanner = document.querySelector('.default-collection-banner');
      if (!existingDefaultBanner) {
        const defaultBannerHTML = `<div class="collection-banner-container">
            <div class="default-collection-banner">
              <p class="banner-text">Shopping <span class="collection-name">${collectionName}</span></p>
            </div>
          </div>`;
        
        insertTarget.insertAdjacentHTML('beforebegin', defaultBannerHTML);
      }
    }
  }
  
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cm_vehicle-widget_button__go')) {
      try { sessionStorage.removeItem('cm_vehicle_cleared'); } catch(e) {}
      setTimeout(updateCollectionHeader, 500);
      setTimeout(updateCollectionHeader, 1000);
    }
  });

  document.addEventListener('click', function(e) {
    const clearBtn = e.target.closest('.cm_vehicle-widget_button__clear');
    if (!clearBtn) return;
    if (!clearBtn.closest || !clearBtn.closest('#cm-ymm-tabs')) return;

    try {
      sessionStorage.setItem('cm_vehicle_cleared', '1');
      sessionStorage.removeItem('cm_vehicle');
    } catch(e) {}

    try { localStorage.removeItem('cm_variant-model'); } catch(e) {}
    try { localStorage.removeItem('cm_variant-garage'); } catch(e) {}

    // Also clear the localStorage YMM keys and tell the PDP fitment banner + enforce-YMM
    // ribbon to re-render to the no-vehicle state. Without this, the ribbon (which reads
    // ymm-*) and the top banner stay green after a CLEAR on a PDP, because no navigation
    // fires there so the PDP-stay interceptor's full-clear branch never runs. Mirrors it.
    try {
      localStorage.removeItem('ymm-year');
      localStorage.removeItem('ymm-make');
      localStorage.removeItem('ymm-model');
    } catch(e) {}
    try {
      window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: null }));
      window.dispatchEvent(new CustomEvent('fitment:refresh'));
    } catch(e) {}

    setTimeout(updateCollectionHeader, 0);
    setTimeout(updateCollectionHeader, 300);
  });

  document.addEventListener('change', function(e) {
    const t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('.cm_select_inner-select[aria-label="Year"], .cm_select_inner-select[aria-label="Make"], .cm_select_inner-select[aria-label="Model"]')) return;
    if (!t.closest('#cm-ymm-tabs')) return;
    setTimeout(updateCollectionHeader, 0);
  });

  const attachYmmObserver = () => {
    const root = document.querySelector('#cm-ymm-tabs');
    if (!root || root.__garageBannerObserved) return;
    root.__garageBannerObserved = true;
    try {
      const mo = new MutationObserver(() => updateCollectionHeader());
      mo.observe(root, { childList: true, subtree: true, attributes: true });
    } catch(e) {}
  };
  attachYmmObserver();
  let ymmObsTry = 0;
  const ymmObsTimer = setInterval(() => {
    ymmObsTry++;
    attachYmmObserver();
    if (ymmObsTry >= 20) clearInterval(ymmObsTimer);
  }, 250);
  
  const headerObserver = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.cm-collection-header__title, h1.cm-collection-header__title')) {
              setTimeout(updateCollectionHeader, 100);
              return;
            }
            if (node.querySelector && node.querySelector('.cm-collection-header__title, h1.cm-collection-header__title')) {
              setTimeout(updateCollectionHeader, 100);
              return;
            }
          }
        }
      }
    }
  });
  
  if (document.body) {
    headerObserver.observe(document.body, { childList: true, subtree: true });
  }
  
  function initializeBanner() {
    updateCollectionHeader();
    setTimeout(updateCollectionHeader, 500);
    setTimeout(updateCollectionHeader, 1000);
    setTimeout(updateCollectionHeader, 2000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBanner);
  } else {
    initializeBanner();
  }
  
  setInterval(updateCollectionHeader, 3000);
})();


(function() {
  function updateSaleFilterLabel() {
    const saleFacet = document.querySelector('.cm_field-oew_on_sale');
    if (!saleFacet) return;
    
    const includedLabel = saleFacet.querySelector('.facetentrykey');
    if (includedLabel && includedLabel.textContent.trim() === 'Included') {
      includedLabel.textContent = 'Sale / Promotion';
    }
  }
  
  function init() {
    updateSaleFilterLabel();
    setTimeout(updateSaleFilterLabel, 500);
    setTimeout(updateSaleFilterLabel, 1000);
    setTimeout(updateSaleFilterLabel, 2000);
  }
  
  const observer = new MutationObserver(function(mutations) {
    updateSaleFilterLabel();
  });
  
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  function updateTypeFilterLabel() {
    const typeFacet = document.querySelector('.cm_field-oew_shopify_product_classifier');
    if (!typeFacet) return;

    // IMPORTANT: Do not reorder/move facet nodes.
    // Convermax may bind filter behavior to the original DOM ordering;
    // moving entries can cause some values (e.g. "Single") to apply the wrong filter
    // and yield empty results.
    const facetDivs = typeFacet.querySelectorAll('.facetdiv');
    facetDivs.forEach((div) => {
      const label = div.querySelector('.facetentrykey');
      if (!label) return;

      const raw = (label.textContent || '').trim();
      // Rename only (idempotent). Keep the underlying Convermax value intact.
      if (/^kit\s*\/\s*package$/i.test(raw) || /^kit\s*\/\s*pkg$/i.test(raw) || /^kit\s*\/\s*pack(age)?$/i.test(raw)) {
        label.textContent = 'Wheel & Tire Package';
      }
    });
  }
  
  function init() {
    updateTypeFilterLabel();
    setTimeout(updateTypeFilterLabel, 500);
    setTimeout(updateTypeFilterLabel, 1000);
    setTimeout(updateTypeFilterLabel, 2000);
  }
  
  const observer = new MutationObserver(function(mutations) {
    updateTypeFilterLabel();
  });
  
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


(function() {
  function parseWheelSize(text) {
    const raw = (text || '').trim();
    const m = raw.match(/^\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*$/i);
    if (!m) return null;
    return {
      diameter: Number(m[1]),
      width: Number(m[2]),
      raw
    };
  }

  function sortFacetDivs(valuesContainer) {
    const facetDivs = Array.from(valuesContainer.querySelectorAll(':scope > .facetdiv'));
    if (facetDivs.length < 2) return;

    const decorated = facetDivs.map((div, index) => {
      const labelEl = div.querySelector('.facetentrykey');
      const parsed = parseWheelSize(labelEl ? labelEl.textContent : '');
      return { div, index, parsed };
    });

    decorated.sort((a, b) => {
      if (a.parsed && b.parsed) {
        if (a.parsed.diameter !== b.parsed.diameter) return a.parsed.diameter - b.parsed.diameter;
        if (a.parsed.width !== b.parsed.width) return a.parsed.width - b.parsed.width;
        return a.index - b.index;
      }
      if (a.parsed && !b.parsed) return -1;
      if (!a.parsed && b.parsed) return 1;
      return a.index - b.index;
    });

    const frag = document.createDocumentFragment();
    decorated.forEach(item => frag.appendChild(item.div));
    valuesContainer.appendChild(frag);
  }

  function sortWheelSizeFacet() {
    const sizeFacet = document.querySelector('.cm_field-wheel_size');
    if (!sizeFacet) return;

    const containers = sizeFacet.querySelectorAll('.cmRepeater_ShowAlwaysValues, .cmRepeater_Values');
    containers.forEach(sortFacetDivs);
  }

  function init() {
    sortWheelSizeFacet();
    setTimeout(sortWheelSizeFacet, 300);
    setTimeout(sortWheelSizeFacet, 800);
    setTimeout(sortWheelSizeFacet, 1500);
  }

  const observer = new MutationObserver(function() {
    sortWheelSizeFacet();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// Intercept Add to Cart submissions and validate variant availability
// Uses collection products.json for bulk availability check (1 request) to avoid rate limiting
(function() {
  'use strict';

  // Track sold-out variants to show appropriate UI
  const soldOutVariants = new Set();
  // Track available variants (true = in stock)
  const variantAvailability = new Map();
  // Track if we've loaded availability data
  let availabilityLoaded = false;
  let availabilityLoading = false;
  // Track forms currently being processed to avoid infinite loops
  const processingForms = new WeakSet();

  // Check if we're on a collection/search page
  function isCollectionPage() {
    return window.location.pathname.includes('/collections/') ||
           window.location.pathname.includes('/search') ||
           document.querySelector('.cm_results-products, .cm_SearchResults');
  }

  // Extract collection handle from URL
  function getCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  // Fetch all products from collection with pagination (single batch approach)
  async function fetchCollectionAvailability() {
    if (availabilityLoading || availabilityLoaded) return;
    availabilityLoading = true;

    const collectionHandle = getCollectionHandle();
    if (!collectionHandle) {
      availabilityLoading = false;
      return;
    }

    try {
      // Fetch first page to get total count
      let page = 1;
      let hasMore = true;

      while (hasMore && page <= 10) { // Max 10 pages (250 products) to avoid too many requests
        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=250&page=${page}`);
        if (!response.ok) break;

        const data = await response.json();
        const products = data.products || [];

        if (products.length === 0) {
          hasMore = false;
          break;
        }

        // Process each product's variants
        products.forEach(product => {
          if (product.variants) {
            product.variants.forEach(variant => {
              const variantId = String(variant.id);
              const isAvailable = variant.available === true;
              variantAvailability.set(variantId, isAvailable);

              if (!isAvailable) {
                soldOutVariants.add(variantId);
              }
            });
          }
        });

        // If we got less than 250, we're done
        if (products.length < 250) {
          hasMore = false;
        } else {
          page++;
          // Small delay between pages to be nice to the server
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      availabilityLoaded = true;

      // Update any already-rendered product buttons
      updateAllSoldOutButtons();

    } catch (error) {
      console.warn('Failed to fetch collection availability:', error);
    } finally {
      availabilityLoading = false;
    }
  }

  // Update all visible sold-out buttons
  function updateAllSoldOutButtons() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        const variantId = String(input.value);
        if (soldOutVariants.has(variantId)) {
          updateSoldOutButton(variantId, true); // true = silent (no alert)
        }
      }
    });
  }

  // Watch for Convermax adding new product cards and update their buttons
  function setupProductObserver() {
    const observer = new MutationObserver((mutations) => {
      let hasNewForms = false;

      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('form[action*="/cart/add"]')) {
                hasNewForms = true;
                break;
              }
              if (node.querySelector && node.querySelector('form[action*="/cart/add"]')) {
                hasNewForms = true;
                break;
              }
            }
          }
        }
        if (hasNewForms) break;
      }

      if (hasNewForms && availabilityLoaded) {
        // Small delay to let Convermax finish rendering
        setTimeout(updateAllSoldOutButtons, 50);
      }
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Check variant availability - now checks cache first
  async function checkAndSubmit(form) {
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) {
      return true;
    }

    const variantId = String(variantInput.value);

    // Check cached availability first
    if (soldOutVariants.has(variantId)) {
      showSoldOutAlert('This product');
      updateSoldOutButton(variantId, false);
      return false;
    }

    // If we have availability data and variant is available, allow submission
    if (availabilityLoaded && variantAvailability.has(variantId)) {
      if (variantAvailability.get(variantId) === true) {
        return true; // In stock, allow submission
      } else {
        // Out of stock
        soldOutVariants.add(variantId);
        showSoldOutAlert('This product');
        updateSoldOutButton(variantId, false);
        return false;
      }
    }

    // Fallback: Test availability via Cart API if we don't have cached data
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      });

      if (response.status === 422) {
        const data = await response.json();
        const isSoldOut = data.message?.toLowerCase().includes('sold out') ||
                         data.description?.toLowerCase().includes('sold out');

        if (isSoldOut) {
          soldOutVariants.add(variantId);
          variantAvailability.set(variantId, false);
          const productName = data.description?.match(/'([^']+)'/)?.[1] || 'This product';
          showSoldOutAlert(productName);
          updateSoldOutButton(variantId, false);
          return false;
        }
      }

      if (response.ok) {
        // Remove the test item we just added
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 0
            })
          });
        } catch (e) {}

        variantAvailability.set(variantId, true);
        return true;
      }

      return true;
    } catch (error) {
      return true;
    }
  }

  // Override native form submit
  const originalSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function() {
    const form = this;

    if (form.action?.includes('/cart/add') && isCollectionPage()) {
      if (processingForms.has(form)) {
        processingForms.delete(form);
        return originalSubmit.call(form);
      }

      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        const variantId = String(variantInput.value);

        // Quick check against cached sold-out list
        if (soldOutVariants.has(variantId)) {
          showSoldOutAlert('This product');
          updateSoldOutButton(variantId, false);
          return; // Block submission
        }
      }

      processingForms.add(form);

      checkAndSubmit(form).then(shouldSubmit => {
        processingForms.delete(form);
        if (shouldSubmit) {
          originalSubmit.call(form);
        }
      }).catch(() => {
        processingForms.delete(form);
        originalSubmit.call(form);
      });

      return;
    }

    return originalSubmit.call(form);
  };

  // Show sold out alert
  function showSoldOutAlert(productName) {
    if (window.__soldOutAlertShown) return;
    window.__soldOutAlertShown = true;

    setTimeout(() => {
      window.__soldOutAlertShown = false;
    }, 3000);

    alert(`Sorry, "${productName}" is currently sold out.`);
  }

  // Update button to show sold out state
  function updateSoldOutButton(variantId, silent) {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (input && String(input.value) === String(variantId)) {
        const button = form.querySelector('button');
        if (button && !button.hasAttribute('data-sold-out')) {
          button.setAttribute('data-sold-out', 'true');
          button.textContent = 'Sold Out';
          button.disabled = true;
          button.style.cursor = 'not-allowed';
          button.style.opacity = '0.7';
        }
      }
    });
  }

  // Intercept form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!isCollectionPage()) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const variantId = String(variantInput.value);

    // Block if known sold out
    if (soldOutVariants.has(variantId)) {
      e.preventDefault();
      e.stopPropagation();
      showSoldOutAlert('This product');
      return false;
    }

    if (processingForms.has(form)) {
      processingForms.delete(form);
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    processingForms.add(form);

    checkAndSubmit(form).then(shouldSubmit => {
      processingForms.delete(form);
      if (shouldSubmit) {
        processingForms.add(form);
        form.submit();
      }
    }).catch(() => {
      processingForms.delete(form);
      processingForms.add(form);
      form.submit();
    });

    return false;
  }, true);

  // Initialize on page load
  function init() {
    if (!isCollectionPage()) return;

    // Fetch availability data (single request per page load)
    fetchCollectionAvailability();

    // Watch for new products being added by Convermax
    setupProductObserver();

    // Also check after a delay in case products are already rendered
    setTimeout(updateAllSoldOutButtons, 1000);
    setTimeout(updateAllSoldOutButtons, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* ---------------------------------------------------------------------------
 * Notion #404 — Availability filter default-unchecked shim
 * Convermax dashboard pre-selects "Available" on the cm_field-stock facet,
 * which hides ~1330 OOS products by default. We can't deselect "Available"
 * directly (Convermax canonicalizes ?stock/Available to base URL since it
 * matches the default), so on collection-page load with no user-picked stock
 * value we programmatically click the "All" row to switch into the
 * show-everything state (URL gains ?stock/All, count = full inventory).
 *
 * The hidden "In-stock Only" + "All" rows are masked by CSS in
 * convermax-custom.css; only the "Available" row is visible, relabeled to
 * "In Stock". Once "All" is selected, that visible row appears unchecked
 * (no .selected class) — matching the unchecked-by-default UX intent.
 *
 * We also intercept clicks on the visible row when it is already selected
 * (the "uncheck" gesture) and re-route them to the "All" row, since clicking
 * a selected default-equivalent value in Convermax is a no-op.
 *
 * Finally we hide the "All" / "Available" / "In-stock Only" chips that
 * Convermax otherwise renders in the active-filter strip — the visible
 * checkbox is the single source of truth for stock-filter state.
 * ------------------------------------------------------------------------- */
(function () {
  var SS_KEY = 'oew_stock_user_picked';
  var STOCK_VALUES = ['All', 'Available', 'In-stock Only'];
  // A link that lands here with a stock value (e.g. the PDP packages "View All" -> ?.../stock/Available)
  // is an explicit pick. Convermax canonicalizes the default value out of the URL before this shim
  // runs again, so remember it from the landing URL for this page view.
  var LANDED_WITH_STOCK = /[?&\/]stock\//.test(location.pathname + location.search);
  function isCollectionPage() {
    // Pages where Convermax renders facets/results and where the default
    // stock-filter state should be unchecked (Notion #404).
    // - /collections/* : canonical collection pages
    // - /pages/search  : destination of the homepage YMM widget submit
    return location.pathname.indexOf('/collections/') === 0
        || location.pathname === '/pages/search';
  }
  function urlHasStock() {
    return /[?&\/]stock\//.test(location.pathname + location.search);
  }
  function userPickedStock() {
    if (urlHasStock()) return true;
    try { return sessionStorage.getItem(SS_KEY) === '1'; } catch (e) { return false; }
  }
  function markUserPicked() {
    try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) {}
  }
  function ensureAllSelected() {
    if (!isCollectionPage()) return;
    if (urlHasStock() || LANDED_WITH_STOCK) return; // explicit stock value in the URL
    if (userPickedStock()) return;        // user-CHECK in this session canonicalized URL → leave alone
    var facet = document.querySelector('.facetholder.cm_field-stock');
    if (!facet) return;
    var allKey = null;
    var keys = facet.querySelectorAll('.facetentrykey');
    for (var i = 0; i < keys.length; i++) {
      if ((keys[i].textContent || '').trim() === 'All') { allKey = keys[i]; break; }
    }
    if (!allKey) return;
    var selected = facet.querySelector('.facetdiv.selected .facetentrykey');
    var selTxt = selected ? (selected.textContent || '').trim() : '';
    if (selTxt === 'All') return;         // already in the desired state
    allKey.click();                        // switch into ?stock/All
  }
  function hideStockChips() {
    // The site's CSS uses `display: flex !important` for chip rows, so we
    // must set !important on our hide to win the cascade.
    var chips = document.querySelectorAll('.cm_FilterChips .facetdiv.cmTemplate_chip, .cm_filterChips .facetdiv.cmTemplate_chip');
    chips.forEach(function (c) {
      var key = c.querySelector('.facetentrykey');
      if (!key) return;
      var txt = (key.textContent || '').trim();
      if (STOCK_VALUES.indexOf(txt) !== -1) {
        c.style.setProperty('display', 'none', 'important');
      }
    });
  }
  function applyAll() {
    ensureAllSelected();
    hideStockChips();
  }
  // Hijack clicks on the visible row 2 ("Available", relabeled "In Stock"):
  //  - If row 2 is unselected → user is "checking" → let Convermax select it
  //    (URL gets canonicalized to base, but "Available" selected internally,
  //    count drops to in-stock).
  //  - If row 2 is selected → user is "unchecking" → Convermax otherwise
  //    treats that as a no-op, so we cancel and click row 3 ("All") instead.
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.facetholder.cm_field-stock .facetdiv');
    if (!hit) return;
    // Only mark "user picked" on clicks against the visible row (:nth-child(2)).
    // Rows 1 and 3 are hidden via CSS, so the only way they get clicked is
    // programmatically (the shim clicking "All", or this intercept re-routing
    // an uncheck). We must not let those programmatic clicks pin the flag,
    // because the flag persists across same-origin navigations and would
    // disable the shim on subsequent visits.
    if (!hit.matches(':nth-child(2)')) return;
    markUserPicked();
    if (hit.classList.contains('selected')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var allRow = document.querySelector('.facetholder.cm_field-stock .facetdiv:nth-child(3) .facetentrykey');
      if (allRow) allRow.click();
    }
  }, true);
  // Re-apply chip-hide on Convermax DOM updates. ensureAllSelected is also
  // called here, but its userPickedStock guard prevents looping with the
  // user-CHECK transition.
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; applyAll(); });
  }
  function startObserver() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    applyAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();


// === Sale Custom Label Injection on Convermax tiles — Notion #412 ===
// Reads product.metafields.oew.{sale_custom_label, b2b_custom_label, on_sale, on_sale_b2b}
// via the /search?section_id=sale-label-data endpoint and injects SALE label badges into
// .cm_product-item / .product-card tiles gated by shop-level + per-product + customer-type rules.

// Inject scoped styles for .cm-sale-label so the shim badges render with the same red-badge
// styling as legacy .label-sale (2026-05-20 follow-up fix — see Notion #412).
(function injectCmSaleLabelStyles() {
  if (document.getElementById('cm-sale-label-styles')) return;
  var style = document.createElement('style');
  style.id = 'cm-sale-label-styles';
  style.textContent = '.cm-sale-label { display:block; background:var(--hight-color,#D2190B); color:#fff; padding:4px 8px; font-size:14px; font-weight:700; line-height:21px; border-radius:0; text-transform:uppercase; letter-spacing:normal; }';
  document.head.appendChild(style);
})();

(function() {
  var saleLabelCache = {}; // keyed by handle
  var pendingFetches = {};

  function readBodyAttr(name) {
    return document.body ? document.body.getAttribute(name) : null;
  }
  function isRetailEnabled() { return readBodyAttr('data-retail-sale-enabled') === 'true'; }
  function isB2BEnabled()    { return readBodyAttr('data-b2b-sale-enabled')    === 'true'; }
  function isCustomerB2B()   { return readBodyAttr('data-customer-b2b')        === 'true'; }

  function chooseLabelText(data) {
    if (!data) return null;
    if (isCustomerB2B()) {
      if (isB2BEnabled() && data.b2bLabel && data.onSaleB2B === 'Included') {
        return data.b2bLabel;
      }
      return null;
    }
    if (isRetailEnabled() && data.retailLabel && data.onSale === 'Included') {
      return data.retailLabel;
    }
    return null;
  }

  function applySaleLabel(card, data) {
    var labelText = chooseLabelText(data);
    if (!labelText) return;
    // De-dup
    if (card.querySelector('.cm-sale-label')) return;

    // Find or create label group container (anchored inside the media area)
    var labelGroup = card.querySelector('.label-group');
    if (!labelGroup) {
      var mediaEl =
        card.querySelector('.cm_product-item__media') ||
        card.querySelector('.product-media') ||
        card.querySelector('.cm_product-item__image-container') ||
        card.querySelector('.cm_product-item__image');
      if (!mediaEl) return;
      if (getComputedStyle(mediaEl).position === 'static') {
        mediaEl.style.position = 'relative';
      }
      labelGroup = document.createElement('div');
      labelGroup.className = 'label-group cm-sale-label-group';
      labelGroup.style.cssText = 'position:absolute;top:0;left:0;display:flex;flex-direction:column;gap:4px;z-index:5;pointer-events:none;';
      mediaEl.appendChild(labelGroup);
    }

    var span = document.createElement('span');
    span.className = 'label label-sale cm-sale-label';
    span.textContent = labelText;
    labelGroup.appendChild(span);
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function enrichSaleLabels() {
    // Bail early if neither gate can ever fire (saves a fetch)
    if (!isRetailEnabled() && !isB2BEnabled()) return;

    var cards = document.querySelectorAll(
      '.product-card:not([data-sale-label-enriched]),' +
      '.cm_product-item:not([data-sale-label-enriched])'
    );
    if (!cards.length) return;

    var cardsByHandle = {};
    cards.forEach(function(card) {
      // NOTE: do NOT mark "pending" here. If Convermax has not populated this card's
      // product id in its search response yet (race during initial page load), we would
      // mark the card "pending" without ever launching a fetch — and the
      // `:not([data-sale-label-enriched])` selector above prevents future shim runs
      // from re-processing it. Causes stuck cards (2026-05-20 incident).
      // Dedup is handled by saleLabelCache (per-handle) and pendingFetches
      // (per-query). We mark "done" only after applying or skipping with confirmed data.
      var handle = getHandleFromCard(card);
      if (!handle) return;
      (cardsByHandle[handle] = cardsByHandle[handle] || []).push(card);
    });

    // Apply cached data first
    var uncachedHandles = [];
    Object.keys(cardsByHandle).forEach(function(handle) {
      if (saleLabelCache[handle]) {
        cardsByHandle[handle].forEach(function(card) {
          applySaleLabel(card, saleLabelCache[handle]);
          card.setAttribute('data-sale-label-enriched', 'done');
        });
      } else {
        uncachedHandles.push(handle);
      }
    });
    if (!uncachedHandles.length) return;

    // Map handles → product IDs via Convermax response (same pattern as B2B inventory)
    var cmResp = window.Convermax && window.Convermax.getSearchResponse && window.Convermax.getSearchResponse();
    var idsToFetch = [];
    if (cmResp && cmResp.items && cmResp.items._items) {
      cmResp.items._items.forEach(function(item) {
        if (!item._item) return;
        var h = item._item.handle;
        var id = item._item.id;
        if (h && id && uncachedHandles.indexOf(h) !== -1) {
          idsToFetch.push(id);
        }
      });
    }
    if (!idsToFetch.length) return;

    var batchSize = 20;
    for (var i = 0; i < idsToFetch.length; i += batchSize) {
      var batch = idsToFetch.slice(i, i + batchSize);
      var query = batch.map(function(id) { return 'id:' + id; }).join(' OR ');
      if (pendingFetches[query]) continue;
      pendingFetches[query] = true;

      (function(q, byHandle) {
        fetch('/search?section_id=sale-label-data&q=' + encodeURIComponent(q) + '&type=product')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            delete pendingFetches[q];
            var m = html.match(/\[[\s\S]*\]/);
            if (!m) return;
            var data;
            try { data = JSON.parse(m[0]); } catch (e) { return; }
            data.forEach(function(product) {
              if (!product || !product.handle) return;
              saleLabelCache[product.handle] = product;
              var cardsForHandle = byHandle[product.handle];
              if (cardsForHandle) {
                cardsForHandle.forEach(function(card) {
                  applySaleLabel(card, product);
                  card.setAttribute('data-sale-label-enriched', 'done');
                });
              }
            });
          })
          .catch(function(err) {
            delete pendingFetches[q];
            console.warn('[sale-label] fetch error:', err);
          });
      })(query, cardsByHandle);
    }
  }

  // Expose so processCards() can trigger it (hook already added near line 789)
  window.__saleLabelEnrich = enrichSaleLabels;

  // Independent self-trigger (ported from Defiant 2026-05-21). The processCards()
  // hook alone retried only at 500/1500ms and stopped once the DOM settled, so cards
  // whose Convermax search response arrived later never got labeled (intermittent
  // race on OEW/4PLAY). Decoupled MutationObserver + rAF + timed re-runs (incl. 3000ms)
  // keep retrying until the response is available.
  var __sl_pending = false;
  function __sl_schedule() {
    if (__sl_pending) return;
    __sl_pending = true;
    requestAnimationFrame(function() { __sl_pending = false; enrichSaleLabels(); });
  }
  function __sl_start() {
    if (!document.body) return;
    new MutationObserver(__sl_schedule).observe(document.body, { childList: true, subtree: true });
    setTimeout(enrichSaleLabels, 500);
    setTimeout(enrichSaleLabels, 1500);
    setTimeout(enrichSaleLabels, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', __sl_start);
  } else {
    __sl_start();
  }
})();


/* ============================================================
   PDP-STAY interceptor (ported from OEW #400/807be95) + 4PLAY /collections/ Shop-by-Vehicle
   bar support. Keeps the customer on the PDP when EITHER the modal (/pages/search) OR the
   black header bar (/collections/<vehicle>) changes YMM. Updated 2026-05-26.
   ============================================================ */
// Collection and search pages keep Convermax's default behaviour.
// Ported from OEW (commit 807be95). 4PLAY differences: also writes sessionStorage.cm_vehicle
// (the canonical store the 4PLAY product-fitment-banner.js reads from), in addition to
// localStorage.ymm-* (which the mobile bar reads).
(function() {
  const onPDP = () => document.body && document.body.classList.contains('template-product');

  // Parse Convermax's search URL format: /pages/search?Year/2015/Make/Chevrolet/Model/Silverado-1500
  const parseCmSearchUrl = (url) => {
    try {
      const u = new URL(url, window.location.href);
      if (!u.pathname.startsWith('/pages/search')) return null;
      // Convermax uses `/` as the separator inside the query string instead of `&`.
      const raw = u.search.replace(/^\?/, '');
      if (!raw) return null;
      const parts = raw.split('/').map(decodeURIComponent);
      const out = {};
      for (let i = 0; i + 1 < parts.length; i += 2) {
        out[parts[i]] = parts[i + 1];
      }
      if (out.Year && out.Make && out.Model) return out;
      return null;
    } catch (e) { return null; }
  };

  const updateFitmentState = (ymm) => {
    try {
      // localStorage ymm-* — read by the mobile YMM bar and the OEW-style top banner.
      localStorage.setItem('ymm-year', ymm.Year);
      localStorage.setItem('ymm-make', ymm.Make);
      localStorage.setItem('ymm-model', ymm.Model);
      // sessionStorage cm_vehicle — read by 4PLAY's product-fitment-banner.js.
      sessionStorage.setItem('cm_vehicle', JSON.stringify({ year: String(ymm.Year), make: String(ymm.Make), model: String(ymm.Model) }));
    } catch (err) {}
    window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: { year: ymm.Year, make: ymm.Make, model: ymm.Model } }));
    window.dispatchEvent(new CustomEvent('fitment:refresh'));
  };

  // Resolve the selected vehicle from Convermax state — used for /collections/<vehicle>
  // navigations (the black Shop-by-Vehicle bar), where the YMM is in the path + Convermax
  // state rather than the query string, so parseCmSearchUrl() can't read it.
  const cmGetVehicle = () => {
    try {
      const v = window.Convermax && typeof window.Convermax.getVehicle === 'function' && window.Convermax.getVehicle();
      if (v && v.Year && v.Make && v.Model) return { Year: String(v.Year), Make: String(v.Make), Model: String(v.Model) };
    } catch (_) {}
    return null;
  };

  // Track recent Convermax widget interactions so the Navigation API handler can distinguish
  // widget-driven navigations (which we intercept on PDP) from legitimate nav-to-search flows
  // (e.g. typing in the search box, clicking SHOP BY VEHICLE in the main nav).
  let recentWidgetInteractionAt = 0;
  const markWidgetInteraction = () => { recentWidgetInteractionAt = Date.now(); };
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cm_vehicle-widget')) markWidgetInteraction();
  }, true);
  document.addEventListener('change', function(e) {
    if (e.target && e.target.closest && e.target.closest('.cm_vehicle-widget')) markWidgetInteraction();
  }, true);
  const isRecentWidgetInteraction = () => (Date.now() - recentWidgetInteractionAt) < 1500;
  // Bridge for the mobile bar's × Clear (in the bar IIFE, which is a separate
  // closure). The bar sets window.__ymmBarClearedAt right before triggering
  // Convermax.clearCurrentRequest(false); honor that as a "recent widget clear"
  // so the navigation interceptor below cancels the /pages/search redirect on
  // PDP. Same 1.5s window as widget clicks.
  const isRecentBarClear = () => (Date.now() - (window.__ymmBarClearedAt || 0)) < 1500;

  // Escape hatch: when the customer clicks an allow-listed link below, programmatic
  // widget-driven navigation should be allowed to proceed without interception.
  let allowNextNavigationUntil = 0;
  const allowNextNavigationFor = (ms) => { allowNextNavigationUntil = Date.now() + ms; };
  const isNavigationAllowed = () => Date.now() < allowNextNavigationUntil;

  // "Shop wheels that fit" link handling (mirrors OEW). The link's default handler in
  // product-fitment-banner.js programmatically populates Convermax's Y/M/M dropdowns and
  // clicks the SHOP button — but Convermax silently refuses to navigate when the chosen
  // vehicle has no products matching the current product's type. Bypass Convermax and
  // navigate directly to the vehicle-filtered collection URL.
  document.addEventListener('click', function(e) {
    const link = e.target.closest('.shop-wheels-fit-link');
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const year  = localStorage.getItem('ymm-year');
    const make  = localStorage.getItem('ymm-make');
    const model = localStorage.getItem('ymm-model');
    if (!year || !make || !model) return;
    const searchUrl = '/pages/search?Year/' + encodeURIComponent(year)
      + '/Make/' + encodeURIComponent(make)
      + '/Model/' + encodeURIComponent(model);
    allowNextNavigationFor(3000);
    window.location.href = searchUrl;
  }, true);

  // Primary mechanism: Navigation API (Chrome 102+). Lets us cancel any navigation.
  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function(e) {
      if (!onPDP()) return;
      if (!e.destination || !e.destination.url) return;
      // Escape hatch: a recent click on an allow-listed control (e.g. "shop wheels that fit")
      // should be allowed to navigate through to the collection/search page.
      if (isNavigationAllowed()) return;
      let dest;
      try { dest = new URL(e.destination.url); } catch (err) { return; }
      // Only intercept same-origin navigations heading to Convermax's search pattern
      if (dest.origin !== window.location.origin) return;
      // 4PLAY's Shop-by-Vehicle bar navigates to a per-vehicle /collections/<handle> page
      // (vehicle lives in the path + Convermax state, NOT the query). The modal uses
      // /pages/search?Year/.../Make/.../Model/... Intercept BOTH so the customer stays on the PDP.
      const toSearch = dest.pathname.startsWith('/pages/search');
      const toVehicleCollection = dest.pathname.startsWith('/collections/');
      if (!toSearch && !toVehicleCollection) return;

      // YMM from the URL query (/pages/search) or, for /collections/, from Convermax state.
      const ymm = parseCmSearchUrl(e.destination.url) || cmGetVehicle();
      // SELECT/CHANGE case. For /collections/ require a recent widget interaction so we don't
      // hijack a customer clicking a normal collection link in the nav.
      if (ymm && (toSearch || (toVehicleCollection && isRecentWidgetInteraction()))) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.intercept === 'function') { try { e.intercept({ handler: async () => {} }); } catch (err) {} }
        updateFitmentState(ymm);
        return;
      }
      // CLEAR case — bare /pages/search produced by widget clear (search path only). Only intercept
      // if the nav was kicked off from the vehicle widget (avoids breaking legitimate searches).
      if (toSearch && (isRecentWidgetInteraction() || isRecentBarClear())) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.intercept === 'function') { try { e.intercept({ handler: async () => {} }); } catch (err) {} }
        try {
          localStorage.removeItem('ymm-year');
          localStorage.removeItem('ymm-make');
          localStorage.removeItem('ymm-model');
          // Also wipe Convermax's and the top-banner's own caches.
          localStorage.removeItem('cm_variant-model');
          localStorage.removeItem('cm_variant-garage');
          sessionStorage.removeItem('cm_vehicle');
        } catch (err) {}
        window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: null }));
        window.dispatchEvent(new CustomEvent('fitment:refresh'));
      }
    });
  }

  // Fallback for browsers without the Navigation API (older Safari).
  document.addEventListener('click', function(e) {
    const goBtn = e.target.closest('.cm_vehicle-widget_button__go');
    if (!goBtn) return;
    if (!onPDP()) return;
    const ymmRoot = goBtn.closest('.cm_vehicle-widget') || document;
    const yearEl  = ymmRoot.querySelector('.cm_select_inner-select[aria-label="Year"]');
    const makeEl  = ymmRoot.querySelector('.cm_select_inner-select[aria-label="Make"]');
    const modelEl = ymmRoot.querySelector('.cm_select_inner-select[aria-label="Model"]');
    const year  = yearEl  && yearEl.value;
    const make  = makeEl  && makeEl.value;
    const model = modelEl && modelEl.value;
    if (!year || !make || !model) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    updateFitmentState({ Year: year, Make: make, Model: model });
  }, true);
})();


// === Custom Card Label Injection on Convermax tiles — Notion #423 ===
// Restores the pre-Convermax "Custom Card Label" badge (e.g. "Single", "Set of 4",
// "W/T Set of 4") on collection/search tiles. Reads product.metafields.oew.custom_card_label
// (metaobject: label + color) via the /search?section_id=card-label-data endpoint and injects
// a .cm-custom-label badge into .cm_product-item / .product-card tiles. No shop-level gate —
// the badge shows whenever the metaobject field is populated, hidden when empty (Notion #423 AC).
// Models the Notion #412 sale-label shim (same handle->id->fetch pattern, same race-safe dedup).

// Scoped styles for .cm-custom-label — Convermax tiles do NOT inherit the theme's
// `.product-card .product-card_header .label` rules (see reference_convermax_tile_css_scope),
// so reproduce the native .label + .label-custom computed styles here. order:2 keeps the card
// label stacked BELOW any sale badge (.cm-sale-label, default order 0) in a shared .label-group.
(function injectCmCardLabelStyles() {
  if (document.getElementById('cm-custom-label-styles')) return;
  var style = document.createElement('style');
  style.id = 'cm-custom-label-styles';
  style.textContent = '.cm-custom-label { display:block; width:fit-content; background:var(--background-label,#4e89b7); color:var(--text-color,#fff); padding:4px 8px; font-size:14px; font-weight:700; line-height:21px; border-radius:0; text-transform:uppercase; letter-spacing:normal; order:2; }';
  document.head.appendChild(style);
})();

(function() {
  var cardLabelCache = {}; // keyed by handle -> {label,color} (or {label:null} cached miss)
  var pendingFetches = {}; // keyed by section query
  var handleIdCache = {};  // handle -> numeric Shopify product id
  var idJsPending = {};    // handles with an in-flight /products/{handle}.js id lookup

  function applyCardLabel(card, data) {
    if (!data || !data.label) return;
    // De-dup against BOTH the shim's own badge AND any native theme-rendered .label-custom
    // (product-item.liquid renders it on fully-native grids — homepage featured collections,
    // PDP related products, cart drawer — where Liquid has metaobject access. Convermax-shell
    // .product-card tiles render no native label, so the shim fills those.) Skip if either exists.
    if (card.querySelector('.label-custom')) return;

    // Reuse an existing label group (theme- or sale-shim-created) or create one in the media area
    var labelGroup = card.querySelector('.label-group');
    if (!labelGroup) {
      var mediaEl =
        card.querySelector('.cm_product-item__media') ||
        card.querySelector('.product-media') ||
        card.querySelector('.cm_product-item__image-container') ||
        card.querySelector('.cm_product-item__image');
      if (!mediaEl) return;
      if (getComputedStyle(mediaEl).position === 'static') {
        mediaEl.style.position = 'relative';
      }
      labelGroup = document.createElement('div');
      labelGroup.className = 'label-group cm-card-label-group';
      labelGroup.style.cssText = 'position:absolute;top:0;left:0;display:flex;flex-direction:column;gap:4px;z-index:5;pointer-events:none;';
      mediaEl.appendChild(labelGroup);
    }

    var span = document.createElement('span');
    span.className = 'label label-custom cm-custom-label';
    if (data.color) span.style.setProperty('--background-label', data.color);
    span.textContent = data.label;
    labelGroup.appendChild(span);
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function enrichCardLabels() {
    var cards = document.querySelectorAll(
      '.product-card:not([data-card-label-enriched]),' +
      '.cm_product-item:not([data-card-label-enriched])'
    );
    if (!cards.length) return;

    var cardsByHandle = {};
    cards.forEach(function(card) {
      // Short-circuit: if this tile already shows a custom label (native product-item.liquid
      // render on fully-native grids — homepage featured collections, PDP related products,
      // cart drawer — where Liquid has metaobject access), the badge is already correct.
      // Mark done and skip — avoids wasted id/label lookups and any chance of a duplicate.
      if (card.querySelector('.label-custom')) {
        card.setAttribute('data-card-label-enriched', 'done');
        return;
      }
      // Do NOT mark "pending" here — same race lesson as Notion #412: if a card's id is not
      // resolvable yet (Convermax response not ready / .js lookup in flight), marking it would
      // orphan the card (the :not([data-card-label-enriched]) selector would skip it forever).
      // Mark "done" only after data is applied. Dedup via cardLabelCache + pendingFetches.
      var handle = getHandleFromCard(card);
      if (!handle) return;
      (cardsByHandle[handle] = cardsByHandle[handle] || []).push(card);
    });

    // Apply cached data first
    var uncachedHandles = [];
    Object.keys(cardsByHandle).forEach(function(handle) {
      if (cardLabelCache.hasOwnProperty(handle)) {
        cardsByHandle[handle].forEach(function(card) {
          applyCardLabel(card, cardLabelCache[handle]);
          card.setAttribute('data-card-label-enriched', 'done');
        });
      } else {
        uncachedHandles.push(handle);
      }
    });
    if (!uncachedHandles.length) return;

    // Resolve handles → numeric product IDs.
    // Fast path: the Convermax search response (collection / PLP — no network).
    var cmResp = window.Convermax && window.Convermax.getSearchResponse && window.Convermax.getSearchResponse();
    if (cmResp && cmResp.items && cmResp.items._items) {
      cmResp.items._items.forEach(function(item) {
        if (item._item && item._item.handle && item._item.id) {
          handleIdCache[item._item.handle] = item._item.id;
        }
      });
    }
    // Fallback: /products/{handle}.js (native search results + any non-Convermax product grid,
    // where getSearchResponse()._items is empty). The .js payload includes the numeric id.
    // Fires once per handle; on resolution it re-schedules the shim, which then batch-fetches
    // the label. Browser HTTP-caches .js (the tile UPC/stock enrichment fetches it too).
    var idsToFetch = [];
    uncachedHandles.forEach(function(h) {
      if (handleIdCache[h]) {
        idsToFetch.push(handleIdCache[h]);
      } else if (!idJsPending[h]) {
        idJsPending[h] = true;
        fetch('/products/' + h + '.js')
          .then(function(r) { return r.json(); })
          .then(function(d) {
            delete idJsPending[h];
            if (d && d.id) { handleIdCache[h] = d.id; __cl_schedule(); }
          })
          .catch(function() { delete idJsPending[h]; });
      }
    });
    if (!idsToFetch.length) return;

    var batchSize = 20;
    for (var i = 0; i < idsToFetch.length; i += batchSize) {
      var batch = idsToFetch.slice(i, i + batchSize);
      var query = batch.map(function(id) { return 'id:' + id; }).join(' OR ');
      if (pendingFetches[query]) continue;
      pendingFetches[query] = true;

      (function(q, byHandle) {
        fetch('/search?section_id=card-label-data&q=' + encodeURIComponent(q) + '&type=product')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            delete pendingFetches[q];
            var m = html.match(/\[[\s\S]*\]/);
            if (!m) return;
            var data;
            try { data = JSON.parse(m[0]); } catch (e) { return; }
            data.forEach(function(product) {
              if (!product || !product.handle) return;
              cardLabelCache[product.handle] = product; // cache even when label is null (avoids refetch)
              var cardsForHandle = byHandle[product.handle];
              if (cardsForHandle) {
                cardsForHandle.forEach(function(card) {
                  applyCardLabel(card, product);
                  card.setAttribute('data-card-label-enriched', 'done');
                });
              }
            });
          })
          .catch(function(err) {
            delete pendingFetches[q];
            console.warn('[card-label] fetch error:', err);
          });
      })(query, cardsByHandle);
    }
  }

  // Expose so processCards() can trigger it (hook added near line 794)
  window.__cardLabelEnrich = enrichCardLabels;

  // Independent self-trigger (same robustness as the Notion #412 sale-label shim): a
  // processCards() piggyback alone stops once the DOM settles, orphaning cards whose
  // Convermax search response arrives late. MutationObserver + rAF + timed re-runs converge.
  var __cl_pending = false;
  function __cl_schedule() {
    if (__cl_pending) return;
    __cl_pending = true;
    requestAnimationFrame(function() { __cl_pending = false; enrichCardLabels(); });
  }
  function __cl_start() {
    if (!document.body) return;
    new MutationObserver(__cl_schedule).observe(document.body, { childList: true, subtree: true });
    setTimeout(enrichCardLabels, 500);
    setTimeout(enrichCardLabels, 1500);
    setTimeout(enrichCardLabels, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', __cl_start);
  } else {
    __cl_start();
  }
})();


/* ===== Notion #401 mobile YMM bar IIFE — ported from OEW to 4PLAY 2026-06-23 (no changes; colors live in convermax-custom.css) ===== */
/* ============================================================
   MOBILE YMM SELECTOR REDESIGN (Notion #401)

   Custom collapsed strip + state machine for the mobile (≤1024px)
   YMM bar. Replaces Convermax's native collapse (suppressed earlier
   in convermax-custom.css). State rules:
     - Vehicle set in localStorage → start COLLAPSED on every page load
       (overrides "remember last state" per user direction).
     - No vehicle → restore last toggle from sessionStorage('ymmMobileCollapsed'),
       defaulting to EXPANDED on first visit.
     - SHOP tapped (ymm:filter event) → force COLLAPSED.
     - × Clear → fire garage:clear, return to default EXPANDED.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 1024px)');
  var SS_KEY = 'ymmMobileCollapsed';
  var BAR_ID = 'ymm-mobile-bar';
  var initialized = false;
  var bar = null;

  function getCmVehicle() {
    if (window.Convermax && typeof window.Convermax.getVehicle === 'function') {
      try {
        var v = window.Convermax.getVehicle();
        if (v && v.Year && v.Make && v.Model) return v;
      } catch (_) {}
    }
    return null;
  }

  // Convermax's own 1-second sync writes localStorage.ymm-{year,make,model}
  // only when the active vehicle is "complete" — for makes/models that have
  // Submodel options in Convermax's data (e.g. Cadillac Escalade), an empty
  // Submodel skips the write. The PDP gate banner in product-fitment-banner.js
  // reads strictly from these localStorage keys, so without a mirror the
  // banner shows "Enter your vehicle" while the YMM bar (which falls back to
  // Convermax.getVehicle()) correctly shows the vehicle. Submodel is hidden
  // on mobile per Notion #401, so this mismatch is the common case there.
  //
  // Gate on sessionStorage.ymmUserCleared so the mirror doesn't fight a CLEAR
  // the user just made. clearVehicle() sets the flag; the next user-driven
  // SHOP / ymmUpdated drops it.
  function mirrorConvermaxToLocalStorage() {
    try {
      if (sessionStorage.getItem('ymmUserCleared') === '1') return false;
    } catch (_) {}
    var y = localStorage.getItem('ymm-year');
    var m = localStorage.getItem('ymm-make');
    var d = localStorage.getItem('ymm-model');
    if (y && m && d) return false;
    var cm = getCmVehicle();
    if (!cm) return false;
    try {
      localStorage.setItem('ymm-year', String(cm.Year));
      localStorage.setItem('ymm-make', String(cm.Make));
      localStorage.setItem('ymm-model', String(cm.Model));
    } catch (_) { return false; }
    try {
      window.dispatchEvent(new CustomEvent('ymmUpdated', {
        detail: { year: String(cm.Year), make: String(cm.Make), model: String(cm.Model) }
      }));
    } catch (_) {}
    return true;
  }

  function isVehicleSet() {
    var y = localStorage.getItem('ymm-year');
    var m = localStorage.getItem('ymm-make');
    var d = localStorage.getItem('ymm-model');
    if (y && m && d) return true;
    // After × Clear on PDP we keep Convermax's in-memory state (we don't call
    // clearCurrentRequest because it always navigates). Honor the same sticky
    // flag here so the bar label resets to "Shop By Vehicle" instead of
    // resurrecting from Convermax.getVehicle() until the user picks again.
    try {
      if (sessionStorage.getItem('ymmUserCleared') === '1') return false;
    } catch (_) {}
    if (getCmVehicle()) {
      mirrorConvermaxToLocalStorage();
      return true;
    }
    return false;
  }

  function getVehicleLabel() {
    var y = localStorage.getItem('ymm-year');
    var m = localStorage.getItem('ymm-make');
    var d = localStorage.getItem('ymm-model');
    if (y && m && d) return [y, m, d].join(' ').trim();
    if (window.Convermax && typeof window.Convermax.getVehicleString === 'function') {
      try {
        var s = window.Convermax.getVehicleString();
        if (s) return s;
      } catch (_) {}
    }
    var cm = getCmVehicle();
    return cm ? [cm.Year, cm.Make, cm.Model].join(' ').trim() : '';
  }

  function shouldStartCollapsed() {
    if (isVehicleSet()) return true;
    return sessionStorage.getItem(SS_KEY) === '1';
  }

  function setBodyState(collapsed) {
    document.body.classList.toggle('ymm-mobile-collapsed', !!collapsed);
    document.body.classList.toggle('ymm-mobile-expanded', !collapsed);
  }

  function persistState(collapsed) {
    try { sessionStorage.setItem(SS_KEY, collapsed ? '1' : '0'); } catch (_) {}
  }

  function buildBar() {
    if (document.getElementById(BAR_ID)) return document.getElementById(BAR_ID);
    var el = document.createElement('div');
    el.id = BAR_ID;
    el.className = 'ymm-mobile-bar';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-expanded', 'false');
    el.innerHTML =
      '<svg class="ymm-mobile-bar__icon" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 11h14l-1.5-4.5A2 2 0 0 0 15.6 5H8.4a2 2 0 0 0-1.9 1.5L5 11zm14 2H5v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4zM7.5 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm9 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>' +
      '</svg>' +
      '<span class="ymm-mobile-bar__label">Shop By Vehicle</span>' +
      '<a class="ymm-mobile-bar__clear" href="#" aria-label="Clear vehicle" style="display:none">× Clear</a>' +
      '<svg class="ymm-mobile-bar__chevron" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M7 10l5 5 5-5z" stroke="currentColor" stroke-width="0.5"/>' +
      '</svg>';
    return el;
  }

  function refreshBar() {
    if (!bar) return;
    var label = bar.querySelector('.ymm-mobile-bar__label');
    var clear = bar.querySelector('.ymm-mobile-bar__clear');
    var newText = isVehicleSet() ? getVehicleLabel() : 'Shop By Vehicle';
    var newTransform = isVehicleSet() ? 'none' : 'uppercase';
    var newLetterSp = isVehicleSet() ? '0' : '0.5px';
    var newClearDisp = isVehicleSet() ? '' : 'none';
    var newAria = String(!document.body.classList.contains('ymm-mobile-collapsed'));
    // Idempotent writes: only mutate the DOM if the value actually changed.
    // Otherwise the MutationObserver below will re-fire refreshBar in a
    // microtask, creating an infinite ping-pong that starves the main
    // thread and blocks DOMContentLoaded from firing on mobile.
    if (label.textContent !== newText) label.textContent = newText;
    if (label.style.textTransform !== newTransform) label.style.textTransform = newTransform;
    if (label.style.letterSpacing !== newLetterSp) label.style.letterSpacing = newLetterSp;
    if (clear.style.display !== newClearDisp) clear.style.display = newClearDisp;
    if (bar.getAttribute('aria-expanded') !== newAria) bar.setAttribute('aria-expanded', newAria);
  }

  function expand() { setBodyState(false); persistState(false); refreshBar(); }
  function collapse() { setBodyState(true); persistState(true); refreshBar(); }
  function toggle() {
    if (document.body.classList.contains('ymm-mobile-collapsed')) expand();
    else collapse();
  }

  function clearVehicle(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    try { localStorage.removeItem('ymm-year'); } catch (_) {}
    try { localStorage.removeItem('ymm-make'); } catch (_) {}
    try { localStorage.removeItem('ymm-model'); } catch (_) {}
    // Also scrub Convermax's own caches so the mirror in mirrorConvermaxToLocalStorage()
    // (and the banner's getVehicleFromConvermaxSources fallback) can't resurface the
    // just-cleared vehicle from cm_variant-model / cm_variant-garage / Convermax.getVehicle().
    try { localStorage.removeItem('cm_variant-model'); } catch (_) {}
    try { localStorage.removeItem('cm_variant-garage'); } catch (_) {}
    try { sessionStorage.removeItem('cm_vehicle'); } catch (_) {}
    // Sticky flag prevents the mirror from rewriting localStorage from Convermax's
    // in-memory state during the brief window before clearCurrentRequest(false)
    // tears Convermax down. Cleared on next ymmUpdated (= user picked a new vehicle).
    try { sessionStorage.setItem('ymmUserCleared', '1'); } catch (_) {}
    // Also set the banner's clear flag so the collection/search green box
    // ("Wheels that fit your …") drops. Its getVehicleInfo() short-circuits to
    // null on cm_vehicle_cleared; without this the banner's 3s self-refresh
    // resurrects cm_vehicle from Convermax's in-memory state and the green box
    // sticks even though the bar reset. Dropped on the next SHOP (go handler).
    try { sessionStorage.setItem('cm_vehicle_cleared', '1'); } catch (_) {}
    window.dispatchEvent(new CustomEvent('garage:clear'));
    window.dispatchEvent(new CustomEvent('fitment:refresh'));
    // After × Clear, drop the user back into the EXPANDED form so they can
    // pick a new vehicle without a second tap. Deliberate deviation from
    // Notion #401 AC ("returns to default collapsed state") per user
    // direction 2026-05-01.
    expand();
    // Reset the global Convermax YMM dropdowns (Year/Make/Model/Submodel) to
    // their empty placeholder so the bar's expanded form reflects the cleared
    // state. We can't call clearCurrentRequest on PDP (always navigates), and
    // localStorage scrub alone doesn't visually reset the <select>s — Convermax's
    // in-memory state still drives their displayed value.
    try {
      var resetWidgetDropdowns = function () {
        ['Year', 'Make', 'Model', 'Submodel'].forEach(function (label) {
          var el = Array.from(document.querySelectorAll('.cm_vehicle-widget .cm_select_inner-select[aria-label="' + label + '"]'))
            .find(function (s) { return !s.closest('#cm-verify-fitment'); });
          if (!el) return;
          if (el.value !== '') {
            el.value = '';
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      };
      resetWidgetDropdowns();
    } catch (_) {}
    // On PDP, skip Convermax.clearCurrentRequest(false) entirely — it always
    // navigates to /pages/search (no non-navigating alternative exists), and
    // dumping the customer to a search page when they just want to swap
    // vehicles on this product is the wrong UX. The bar's localStorage scrub
    // + ymmUserCleared flag + dispatched events are enough: bar resets to
    // "Shop By Vehicle", PDP banner re-renders to "Enter your vehicle", the
    // hidden cm-verify-fitment widget keeps any stale Convermax in-memory
    // state from leaking visually. As defense-in-depth on Chromium browsers,
    // mark a bar-clear timestamp so the Navigation API interceptor cancels
    // any navigation that does sneak through.
    try { window.__ymmBarClearedAt = Date.now(); } catch (_) {}
    var onProductPage = document.body && document.body.classList && document.body.classList.contains('template-product');
    if (onProductPage) return;
    if (window.Convermax && typeof window.Convermax.clearCurrentRequest === 'function') {
      try { window.Convermax.clearCurrentRequest(false); } catch (_) {}
    }
  }

  function mountBar() {
    if (bar && document.body.contains(bar)) return;
    var ymm = document.getElementById('cm-ymm');
    if (!ymm || !ymm.parentNode) return;
    bar = buildBar();
    ymm.parentNode.insertBefore(bar, ymm);
    bar.addEventListener('click', function (e) {
      if (e.target.closest('.ymm-mobile-bar__clear')) return;
      toggle();
    });
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
    var clearLink = bar.querySelector('.ymm-mobile-bar__clear');
    if (clearLink) clearLink.addEventListener('click', clearVehicle);
  }

  function unmountBar() {
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    bar = null;
    document.body.classList.remove('ymm-mobile-collapsed', 'ymm-mobile-expanded');
  }

  var initialStateApplied = false;

  function applyInitialState() {
    setBodyState(shouldStartCollapsed());
    refreshBar();
    initialStateApplied = true;
  }

  function reapplyOnRemount() {
    // Convermax thrashed the DOM (e.g., search/filter update) and removed our
    // bar. Re-mount and resync label, but DO NOT force-collapse — that should
    // only happen on the genuine page load. Otherwise an in-page re-render
    // would yank the user back to collapsed every time they expand.
    refreshBar();
  }

  // PDP Improvements #13: the observer below outlived teardown() and re-mounted the bar after a
  // resize back to desktop, where the bar has no styles (its car icon rendered 1440px wide), and
  // every return to mobile bound a second set of listeners. Bind once; observe only while mobile.
  var mo = null;

  function init() {
    if (initialized) return;
    if (!MOBILE_MQ.matches) return;
    initialized = true;

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (document.getElementById('cm-ymm')) {
        clearInterval(poll);
        mountBar();
        applyInitialState();
      } else if (attempts > 60) {
        clearInterval(poll);
      }
    }, 100);

    // MutationObserver re-mounts the bar if Convermax thrashes the DOM and
    // resyncs the label. Two safeguards against recursive self-triggering
    // (which would block the main thread and prevent DOMContentLoaded):
    //   1. refreshBar() writes are idempotent (no-op when values match).
    //   2. We coalesce callbacks into one rAF so a flood of mutations from
    //      Convermax can't fire 1000s of refreshBar() calls per second.
    if (mo) {
      // Back to mobile after a resize: listeners are already bound, just resume observing.
      mo.observe(document.body, { childList: true, subtree: true });
      return;
    }

    var moScheduled = false;
    mo = new MutationObserver(function () {
      if (moScheduled) return;
      moScheduled = true;
      requestAnimationFrame(function () {
        moScheduled = false;
        if (!initialized) return;
        if (!document.getElementById('cm-ymm')) return;
        if (!bar || !document.body.contains(bar)) {
          mountBar();
          if (!initialStateApplied) applyInitialState();
          else reapplyOnRemount();
        } else {
          refreshBar();
        }
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('ymm:filter', function () {
      if (!initialized) return;
      setTimeout(function () { collapse(); }, 50);
    });
    // Convermax doesn't fire ymm:filter — listen for the actual SHOP button
    // tap so we collapse after a vehicle is filtered in-page (e.g. on the
    // All Products / collection routes where Convermax doesn't navigate).
    document.addEventListener('click', function (e) {
      if (!MOBILE_MQ.matches) return;
      if (!e.target.closest('.cm_vehicle-widget_button__go')) return;
      // Clicking SHOP is a positive vehicle commit, so drop any sticky
      // "user cleared" flag. Without this, after a prior × Clear the flag
      // stays set, isVehicleSet() short-circuits to false, and the collapsed
      // bar keeps showing "Shop By Vehicle" with the × Clear hidden even
      // though Convermax now has an active vehicle (e.g. selecting a vehicle
      // via the native widget on the search/collection page). #401 fix.
      try { sessionStorage.removeItem('ymmUserCleared'); } catch (_) {}
      // 100ms gives Convermax's own click handler time to write vehicle state
      // before we collapse, avoiding any race against its in-page filter.
      setTimeout(function () { collapse(); }, 100);
    });
    // Vehicle cleared from anywhere — just resync label/×Clear visibility.
    // Don't change collapsed/expanded state: clearVehicle() (× Clear) sets it
    // explicitly, and Convermax's own CLEAR button is inside the expanded form.
    window.addEventListener('garage:clear', function () {
      setTimeout(refreshBar, 50);
    });
    window.addEventListener('fitment:refresh', refreshBar);
    // A genuine vehicle pick (Y/M/M present in detail) drops the just-cleared
    // sticky flag so mirrorConvermaxToLocalStorage can run again on subsequent
    // routes. Also resync the label.
    window.addEventListener('ymmUpdated', function (e) {
      if (e && e.detail && e.detail.year && e.detail.make && e.detail.model) {
        try { sessionStorage.removeItem('ymmUserCleared'); } catch (_) {}
      }
      refreshBar();
    });
    window.addEventListener('storage', function (e) {
      if (e.key && e.key.indexOf('ymm-') === 0) refreshBar();
    });
  }

  function teardown() {
    if (!initialized) return;
    initialized = false;
    if (mo) mo.disconnect();
    unmountBar();
  }

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', function (e) {
      if (e.matches) init();
      else teardown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
 * Notion #429 — reconcile localStorage ymm-* with Convermax on page load
 *
 * The top fitment ribbon (product-fitment-banner.js) and the disclaimer above
 * Add to Cart (product-form.js) both treat localStorage ymm-year/make/model as
 * authoritative and deliberately do NOT fall back to Convermax while those keys
 * are populated. But the homepage / global YMM widget only sets Convermax state
 * and navigates — it never writes ymm-*. Results:
 *
 *   - ymm-* empty (vehicle only ever set from the homepage)
 *       -> ribbon shows "Enter your vehicle" while the bar and the disclaimer
 *          are correct.                                        (#429 bug 2)
 *   - ymm-* stale (a PDP change wrote it, then the shopper changed vehicle on
 *     the homepage)
 *       -> ribbon AND disclaimer both show the previous vehicle. (#429 bug 1)
 *
 * mirrorConvermaxToLocalStorage() above was meant to cover this but (a) only
 * backfills when the keys are empty, so it never corrects a stale vehicle, and
 * (b) lives inside the mobile YMM bar IIFE, which returns early above 1024px —
 * so on desktop it never runs at all.
 *
 * This block runs on every viewport. It is a ONE-SHOT at page load, on purpose:
 * the PDP "Enter your vehicle" modal writes ymm-* immediately but syncs the
 * Convermax widget through staggered 600ms + 600ms change events, so for ~1.2s
 * ymm-* is newer than Convermax. A continuously-running reconcile would read
 * Convermax's older value during that window and revert the shopper's pick.
 * We therefore reconcile once, as soon as Convermax first reports a vehicle,
 * and stand down permanently on any user-driven ymmUpdated.
 *
 * Never clears ymm-*: if Convermax has no vehicle we do nothing. Clearing stays
 * the job of clearVehicle(), which is also why the ymmUserCleared guard is kept.
 * ------------------------------------------------------------------------- */
(function () {
  var TICK_MS = 300;
  var MAX_WAIT_MS = 20000;
  var SOURCE = 'ymm-reconcile-429';

  var stopped = false;
  var waited = 0;
  var timer = null;

  function stop() {
    stopped = true;
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  // Any genuine vehicle pick (modal, widget, PDP-stay intercept) means the page
  // state is now user-driven and must not be second-guessed.
  window.addEventListener('ymmUpdated', function (e) {
    if (e && e.detail && e.detail.source === SOURCE) return;
    stop();
  });

  function convermaxVehicle() {
    try {
      if (window.Convermax && typeof window.Convermax.getVehicle === 'function') {
        var v = window.Convermax.getVehicle();
        if (v && v.Year && v.Make && v.Model) return v;
      }
    } catch (_) {}
    return null;
  }

  function reconcile() {
    if (stopped) return;

    try {
      if (sessionStorage.getItem('ymmUserCleared') === '1') { stop(); return; }
    } catch (_) {}

    var cm = convermaxVehicle();
    if (!cm) return; // Convermax not ready yet (or genuinely no vehicle) — keep waiting

    var year = String(cm.Year);
    var make = String(cm.Make);
    var model = String(cm.Model);

    var y, m, d;
    try {
      y = localStorage.getItem('ymm-year');
      m = localStorage.getItem('ymm-make');
      d = localStorage.getItem('ymm-model');
    } catch (_) { stop(); return; }

    // Convermax has answered, so this was our one shot either way.
    stop();

    if (y === year && m === make && d === model) return; // already in sync

    try {
      localStorage.setItem('ymm-year', year);
      localStorage.setItem('ymm-make', make);
      localStorage.setItem('ymm-model', model);
    } catch (_) { return; }

    // Repaint the ribbon (listens to both) and the disclaimer.
    try {
      window.dispatchEvent(new CustomEvent('ymmUpdated', {
        detail: { year: year, make: make, model: model, source: SOURCE }
      }));
    } catch (_) {}
    try {
      window.dispatchEvent(new CustomEvent('fitment:refresh'));
    } catch (_) {}
  }

  function start() {
    reconcile();
    if (stopped) return;
    timer = setInterval(function () {
      waited += TICK_MS;
      if (waited >= MAX_WAIT_MS) { stop(); return; }
      reconcile();
    }, TICK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
